<template>
    <div class="user-stat-page-container">
        <div v-if="loading" class="d-flex justify-content-center m-2 tip_body" style="height: 10px;">
            <CSpinner
                color="info"
                style="width:4rem;height:4rem;"
            />
        </div>
        <CCard v-else bodyWrapper class="tip_body">
            <div class="username">
                <div class="d-flex" style="color: blue; font-weight: 600;">
                    <Avatar 
                        :key="stat.userAvatar"
                        :size="55"
                        :src="stat.userAvatar"
                        :username="stat.userName"
                        :userId="stat.userId"
                    />
                    &nbsp;<p class="next_avatar_name_p">{{ stat.userName}}</p>
                </div>
            </div>
            <div class="stat">
                <!-- <div class="sub_stat"> -->
                
                <div class="tips">
                    <div>{{ $t('Tips') }}</div>
                    <div>{{ total_stat.total_tips}}<span v-if="userId == 0">({{ real_stat.total_tips }})</span></div>
                </div>
                <div class="profit-pts">
                    <div>{{ $t('Profit PTs') }}</div>
                    <div :class="{
                        'limegreen': total_stat.profit_pts >= 0,
                        'red': total_stat.profit_pts < 0}">
                        {{ total_stat.profit_pts}}
                        <span  v-if="userId == 0" :class="{
                            'limegreen': real_stat.profit_pts >= 0,
                            'red': real_stat.profit_pts < 0}">
                            ({{ real_stat.profit_pts }})
                        </span>
                    </div>                    
                </div>
                <div class="roi">
                    <div>{{ $t('ROI %') }}</div>
                    <div :class="{
                        'limegreen': total_stat.roi >= 0,
                        'red': total_stat.roi < 0}">
                        {{ total_stat.roi}}
                        <span  v-if="userId == 0" :class="{
                            'limegreen': real_stat.roi >= 0,
                            'red': real_stat.roi < 0}">
                            ({{ real_stat.roi }})
                        </span>
                    </div>
                </div>
                <div class="w-rate">
                    <div>{{ $t('W/Rate') }}</div>
                    <div :class="{
                        'limegreen': total_stat.w_rate >= 0,
                        'red': total_stat.w_rate < 0}">
                        {{ total_stat.w_rate}}
                        <span  v-if="userId == 0" :class="{
                            'limegreen': real_stat.w_rate >= 0,
                            'red': real_stat.w_rate < 0}">
                            ({{ real_stat.w_rate }})
                        </span>
                    </div>
                </div>
                <div class="avg_odd">
                    <div>{{ $t('Avg Odd')}}</div>
                    <div>
                        {{ total_stat.avg_odd }} ({{ real_stat.avg_odd }})
                       
                    </div>
                </div>
                <div class="followers">
                    <div>Followers</div>
                    <div class="action-box" :key="total_stat.followers + ' ' + stat.followers">
                        <div :class="{
                                'action': true,
                                'selected': userIsFollowed
                            }">
                            {{ total_stat.followers}}
                            <span  v-if="$route.params.userId != loggedInUser.user_id"
                                v-c-tooltip="userIsFollowed ? $t('You already followed this tipster') : $t('Follow this tipster')"
                                @click="handleFollowUser_($route.params.userId, loggedInUser.user_id)">
                                <CIcon name="cil-user-follow" />
                            </span>
                            <span v-else>
                                <CIcon name="cil-user-follow" class="disabled" />
                            </span>
                        </div>
                    </div>
                    
                </div>
                
            </div>
            
            <div class="strategy_name_bar">
                <p class="strategy_name1">Strategy name</p>
                <div class="stat" style="margin-top: 0px">
                    <span class="strategy-name">{{strategy.name}}</span>
                    <div class="followers">
                        <div>Followers</div>

                        <div class="action-box" :key="total_stat.followers + ' ' + stat.followers">
                            <div :class="{
                                'action': true,
                                'selected': strategyIsFollowed
                            }">
                                {{ stat.followers}}
                                <span  v-if="$route.params.userId != loggedInUser.user_id && strategy.name != 'default'"
                                    v-c-tooltip="strategyIsFollowed ? 'You already followed this strategy' : 'Follow this strategy'"
                                    @click="handleFollowStrategy_(strategy._id)">
                                    <CIcon name="cil-user-follow" />
                                </span>
                                <span v-else>
                                    <CIcon name="cil-user-follow" class="disabled" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex">
                <div class="font-weight-bold">Description:&nbsp;</div>
                <div style="flex: 1">{{ strategy.description }}</div>
            </div>
            <div class="stat stat1">
                <!-- <div class="sub_stat"> -->
                
                <div class="tips">
                    <div>Tips</div>
                    <div>{{ stat.total_tips}}</div>
                </div>
                <div class="profit-pts">
                    <div>Profit PTs</div>
                    <div v-if="stat.profit_pts >= 0" style="color: limegreen;">{{ stat.profit_pts}}</div>
                    <div v-else style="color: red;">{{ stat.profit_pts}}</div>
                </div>
                <div class="roi">
                    <div>ROI %</div>
                    <div v-if="stat.roi >= 0" style="color: limegreen;">{{ stat.roi}}</div>
                    <div v-else style="color: red;">{{ stat.roi}}</div>
                </div>
                <div class="w-rate">
                    <div>W/Rate</div>
                    <div v-if="stat.w_rate >= 0" style="color: limegreen;">{{ stat.w_rate}}</div>
                    <div v-else style="color: red;">{{ stat.w_rate}}</div>
                </div>
                <div class="avg_odd">
                    <div>{{ $t('Avg Odd')}}</div>
                    <div>
                        {{ stat.avg_odd }}
                       
                    </div>
                </div>
                <div style="display: flex; align-items: center;">                    
                    <CButton color="success" class="mx-1 detail_button2 strategy_stats_button" @click="handleStatsClick">{{$t('Stats')}}</CButton>
                    <CButton color="success" class="mx-1 detail_button2 strategy_stats_button" @click="handleDetailClick">{{$t('Details')}}</CButton>
                </div>
               <!--  <div style="display: flex; align-items: center;">                    
                    <CButton color="success" class="mx-1 detail_button2 strategy_stats_button" @click="handleDetailClick">{{$t('Details')}}</CButton>
                </div> -->
                
                <!-- <div v-if="userId === stat.userId" class="resetCount">
                    <div>Reset Count</div>
                    <div>{{ stat.resetCount}}</div>
                </div>
                <CButton 
                    v-if="userId === stat.userId"
                    color="info"
                    @click="handleReset"
                    style="background-color: #3399ff">
                    Reset stat
                </CButton> -->
            </div>
            
            <CCol sm="12">
                <div style="margin-bottom: 5px;">
                    <span style="color: blue;">{{ $t("Filters") }}</span>
                </div>
                <table class="search-table">
                    <tr style="background: #b7eafc;">
                        <th class="dualHeader1" colspan="1">{{ $t("min odd") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("max odd") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("tot bets filtered") }}</th>
                        <th class="dualHeader1" colspan="1" style="background: white"></th>
                        <th class="dualHeader1" colspan="1">{{ $t("Back increment %") }}
                        </th>
                        <th class="dualHeader1" colspan="1">{{ $t("Lay increment %") }}</th>
                        <th class="dualHeader1" colspan="1">BF %</th>
                        <th class="dualHeader1" colspan="1" style="background: white"></th>                        
                        <th class="dualHeader1" colspan="1">{{ $t("rank") }}</th>
                    </tr>
                    <tr> 
                         <td style="padding: 0px">
                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="min_odd"></CInput>
                        </td> 
                         <td style="padding: 0px">
                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="max_odd"></CInput>
                        </td> 
                        <td style="padding: 0px">
                           {{ tot_bets_filtered }}
                        </td>
                        <th class="dualHeader1" colspan="1" style="background: white"></th>
                        <td style="padding: 0px">
                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="back_inc"></CInput>
                        </td> 
                        <td style="padding: 0px">
                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="lay_inc"></CInput>
                        </td> 
                        <td style="padding: 0px">
                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="bf"></CInput>
                        </td>
                        <th class="dualHeader1" colspan="1" style="background: white"></th>
                        
                        <td style="padding: 0px">
                            <CSelect
                                :options="rankOptions"
                                :value.sync="rankOption"
                                style="margin-bottom:  0px;" 
                            />
                        </td>
                    </tr>
                    <tr style="background: #b7eafc;">                        
                        <th class="dualHeader1" colspan="1">{{ $t("From Date") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("To Date") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Swap Odd") }}</th>
                        <th class="dualHeader1" colspan="1" style="background: white"></th>
                        <th class="dualHeader1" colspan="1">{{ $t("Swap Result") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Without CO") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Without Cover") }}</th>
                        <th class="dualHeader1" colspan="1" style="background: white"></th>
                        
                        <td style="padding: 0px">
                            <CInput style="margin-bottom:  0px;" type="text" :value.sync="rank_min" placeholder="min"></CInput>
                        </td>
                        
                    </tr>                    
                    <tr> 
                        <td style="padding: 0px">
                            <CSelect
                                :options="fromDateOptions"
                                :value.sync="fromDate"
                                style="margin-bottom:  0px;" 
                            />
                        </td>
                        <td style="padding: 0px">
                            <CSelect
                                :options="toDateOptions"
                                :value.sync="toDate"
                                style="margin-bottom:  0px;" 
                            />
                        </td>
                        <td style="padding: 0px">
                           <CInputCheckbox class="check-box" style="margin-top: -10px !important;"
                                :checked.sync = "swap_odd"
                            >
                        </CInputCheckbox>
                        </td>
                        
                        <th class="dualHeader1" colspan="1" style="background: white"></th>
                        <td style="padding: 0px">
                           <CInputCheckbox class="check-box" style="margin-top: -10px !important;"
                                :checked.sync = "swap_result"
                            >
                        </CInputCheckbox>
                        </td>
                        
                        <td style="padding: 0px">
                           <CInputCheckbox class="check-box" style="margin-top: -10px !important;"
                                :checked.sync = "without_co"
                            >
                        </CInputCheckbox>
                        </td>

                        <td style="padding: 0px">
                           <CInputCheckbox class="check-box" style="margin-top: -10px !important;"
                                :checked.sync = "without_cover"
                            >
                        </CInputCheckbox>
                        </td>
                        <th class="dualHeader1" colspan="1" style="background: white"></th>
                        
                        <td style="padding: 0px">
                            <CInput style="margin-bottom:  0px;" type="text" :value.sync="rank_max" placeholder="max"></CInput>
                        </td>
                    </tr>
                </table>
                <div> 
                    <div class="dualHeader1" style="max-width: 500px;background: rgb(183, 234, 252); padding: 8px; font-weight: bold; text-align: center; font-size: 13.5px;">{{ $t("country/league") }}</div>
                    <div style="padding: 0px; max-width: 500px;">
                       <multiselect 
                            v-model="leagueList" 
                            :options="leagueOptions" 
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="true"                        
                            group-values="leagues" 
                            group-label="all" 
                            :group-select="true" 
                            placeholder="Type to search" 
                            track-by="country_league" 
                            label="country_league">
                            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} leagues selected</span></template>
                            <template slot="tag">{{ '' }}</template>
                        </multiselect>
                    </div>
                </div>
            </CCol>
            
            <CCol sm="12">
                <div style="margin-bottom: 5px; margin-top: 15px;">
                    <span style="color: blue;">{{ $t("Points") }}</span>
                </div>
                <table class="search-table">
                    
                    <tr style="background: #b7eafc;">                        
                        <th class="dualHeader1" colspan="1" style="min-width: 150px;">{{ $t("Lay") }}</th>
                        <th class="dualHeader1" colspan="1" style="min-width: 100px;">{{ $t("Points") }}</th>
                        <th class="dualHeader1" colspan="1" style="min-width: 100px;">{{ $t("Roi") }} (%)</th>
                        <th class="dualHeader1" colspan="1" style="min-width: 100px;">{{ $t("W/Rate") }} (%)</th>
                        <th class="dualHeader1" colspan="1" style="min-width: 100px;">{{ $t("Avg Odd") }}</th>
                    </tr>
                    <tr style="height: 33px;">
                        <td style="padding: 0px">
                            {{ $t("liability") }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : points_result.lay_lia.points > 0, 'negative-mark' : points_result.lay_lia.points < 0}">
                            {{ points_result.lay_lia.points }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : points_result.lay_lia.roi > 0, 'negative-mark' : points_result.lay_lia.roi < 0}">
                            {{ points_result.lay_lia.roi }}
                        </td> 

                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_lia.w_rate > 0, 'negative-mark' : compounding_result.lay_lia.w_rate < 0}">
                            {{ compounding_result.lay_lia.w_rate }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_lia.avg_odd > 0, 'negative-mark' : compounding_result.lay_lia.avg_odd < 0}">
                            {{ compounding_result.lay_lia.avg_odd }}
                        </td> 
                        
                    </tr>
                    <tr style="height: 33px;">
                        
                        <td style="padding: 0px">
                            {{ $t("payout") }}
                        </td> 
                       <td style="padding: 0px" :class="{'positive-mark' : points_result.lay_pay.points > 0, 'negative-mark' : points_result.lay_pay.points < 0}">
                            {{ points_result.lay_pay.points }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : points_result.lay_pay.roi > 0, 'negative-mark' : points_result.lay_pay.roi < 0}">
                            {{ points_result.lay_pay.roi }}
                        </td> 

                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_pay.w_rate > 0, 'negative-mark' : compounding_result.lay_pay.w_rate < 0}">
                            {{ compounding_result.lay_pay.w_rate }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_pay.avg_odd > 0, 'negative-mark' : compounding_result.lay_pay.avg_odd < 0}">
                            {{ compounding_result.lay_pay.avg_odd }}
                        </td> 
                        
                    </tr>
                    <tr style="background: #b7eafc;">
                        
                        <th class="dualHeader1" colspan="1">{{ $t("Back") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Points") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Roi") }} (%)</th>
                        <th class="dualHeader1" colspan="1" >{{ $t("W/Rate") }} (%)</th>
                        <th class="dualHeader1" colspan="1" >{{ $t("Avg Odd") }}</th>
                        
                    </tr>
                    <tr style="height: 33px;">                        
                        <td style="padding: 0px">
                            {{ $t("liability") }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : points_result.back.points > 0, 'negative-mark' : points_result.back.points < 0}">
                            {{ points_result.back.points }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : points_result.back.roi > 0, 'negative-mark' : points_result.back.roi < 0}">
                            {{ points_result.back.roi }}
                        </td> 

                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.back.w_rate > 0, 'negative-mark' : compounding_result.back.w_rate < 0}">
                            {{ compounding_result.back.w_rate }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.back.avg_odd > 0, 'negative-mark' : compounding_result.back.avg_odd < 0}">
                            {{ compounding_result.back.avg_odd }}
                        </td> 
                    </tr>
                </table>
            </CCol>
            <CCol sm="12">
                <div style="margin-bottom: 5px; margin-top: 15px;">
                    <span style="color: blue;">{{ $t("Leverage stake") }}</span>
                </div>
                <table class="search-table">
                    
                    <tr style="background: #b7eafc;">
                        <th class="dualHeader1" colspan="1" style="background: #b7eafc;">{{ $t("Leverage stake") }}</th>
                        <th class="dualHeader1" colspan="1" style="min-width: 150px;">{{ $t("Lay") }}</th>
                        <!-- <th class="dualHeader1" colspan="1" style="min-width: 100px;">{{ $t("Points") }}</th> -->
                        <th class="dualHeader1" colspan="1" style="min-width: 100px;">€</th>
                        <th class="dualHeader1" colspan="1" style="min-width: 100px;">{{ $t("Roi") }} (%)</th>
                        <th class="dualHeader1" colspan="1" style="min-width: 100px;">{{ $t("W/Rate") }} (%)</th>
                        <th class="dualHeader1" colspan="1" style="min-width: 100px;">{{ $t("Avg Odd") }}</th>
                        
                    </tr>
                    <tr style="height: 33px;">
                        <th class="dualHeader1" colspan="1">1 pt = x €</th>
                        <td style="padding: 0px">
                            {{ $t("liability") }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : leverage_result.lay_lia.points > 0, 'negative-mark' : leverage_result.lay_lia.points < 0}">
                            {{ leverage_result.lay_lia.points }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : leverage_result.lay_lia.roi > 0, 'negative-mark' : leverage_result.lay_lia.roi < 0}">
                            {{ leverage_result.lay_lia.roi }}
                        </td> 

                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_lia.w_rate > 0, 'negative-mark' : compounding_result.lay_lia.w_rate < 0}">
                            {{ compounding_result.lay_lia.w_rate }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_lia.avg_odd > 0, 'negative-mark' : compounding_result.lay_lia.avg_odd < 0}">
                            {{ compounding_result.lay_lia.avg_odd }}
                        </td> 
                        
                    </tr>
                    <tr style="height: 33px;">
                        <td style="padding: 0px">
                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="leverage_stake"></CInput>
                        </td> 
                        <td style="padding: 0px">
                            {{ $t("payout") }}
                        </td> 
                       <td style="padding: 0px" :class="{'positive-mark' : leverage_result.lay_pay.points > 0, 'negative-mark' : leverage_result.lay_pay.points < 0}">
                            {{ leverage_result.lay_pay.points }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : leverage_result.lay_pay.roi > 0, 'negative-mark' : leverage_result.lay_pay.roi < 0}">
                            {{ leverage_result.lay_pay.roi }}
                        </td> 

                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_pay.w_rate > 0, 'negative-mark' : compounding_result.lay_pay.w_rate < 0}">
                            {{ compounding_result.lay_pay.w_rate }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_pay.avg_odd > 0, 'negative-mark' : compounding_result.lay_pay.avg_odd < 0}">
                            {{ compounding_result.lay_pay.avg_odd }}
                        </td> 
                        
                    </tr>
                    <tr>
                        <td></td>
                        <th class="dualHeader1" colspan="1" style="background: #b7eafc;">{{ $t("Back") }}</th>
                        <!-- <th class="dualHeader1" colspan="1" style="background: #b7eafc;">{{ $t("Points") }}</th> -->
                        <th class="dualHeader1" colspan="1" style="background: #b7eafc;">€</th>
                        <th class="dualHeader1" colspan="1" style="background: #b7eafc;">{{ $t("Roi") }} (%)</th>
                        <th class="dualHeader1" colspan="1" style="background: #b7eafc;" >{{ $t("W/Rate") }} (%)</th>
                        <th class="dualHeader1" colspan="1" style="background: #b7eafc;" >{{ $t("Avg Odd") }}</th>
                        
                    </tr>
                    <tr style="height: 33px;">
                        <td></td>
                        <td style="padding: 0px">
                            {{ $t("liability") }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : leverage_result.back.points > 0, 'negative-mark' : leverage_result.back.points < 0}">
                            {{ leverage_result.back.points }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : leverage_result.back.roi > 0, 'negative-mark' : leverage_result.back.roi < 0}">
                            {{ leverage_result.back.roi }}
                        </td> 

                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.back.w_rate > 0, 'negative-mark' : compounding_result.back.w_rate < 0}">
                            {{ compounding_result.back.w_rate }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.back.avg_odd > 0, 'negative-mark' : compounding_result.back.avg_odd < 0}">
                            {{ compounding_result.back.avg_odd }}
                        </td> 
                    </tr>
                </table>
            </CCol> 
            
            <CCol sm="12">
                <div style="margin-bottom: 5px; margin-top: 15px;">
                    <span style="color: blue;">Compounding</span>
                </div>
                <table class="search-table">
                    <tr style="background: #b7eafc;">
                        <th class="dualHeader1" colspan="1">{{ $t("start bankroll") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("size %") }}</th>
                    </tr>
                    <tr>
                        <td style="padding: 0px">
                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="start_bankroll"></CInput>
                        </td> 
                        <td style="padding: 0px">
                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="compounding_size"></CInput>
                        </td>
                    </tr>
                    <tr style="background: #b7eafc;">
                        <th class="dualHeader1" colspan="1">{{ $t("Back") }}</th>
                    </tr>
                    <tr style="background: #b7eafc;">
                        <th class="dualHeader1" colspan="1">{{ $t("Gross profit") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Gross loss") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Profit factor") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("DDMAX %") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Net Profit") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("investimento") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("ROI") }} (%)</th>
                        <th class="dualHeader1" colspan="1">{{ $t("ROE") }} (%)</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Avg Odd") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("W/Rate") }} (%)</th>
                    </tr>
                    <tr style="height: 33px;">
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.back.gross_profit > 0, 'negative-mark' : compounding_result.back.gross_profit < 0}">
                            {{ compounding_result.back.gross_profit.toFixed(2) }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.back.gross_loss > 0, 'negative-mark' : compounding_result.back.gross_loss < 0}">
                            {{ compounding_result.back.gross_loss.toFixed(2) }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.back.profit_factor > 0, 'negative-mark' : compounding_result.back.profit_factor < 0}">
                            {{ compounding_result.back.profit_factor }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.back.ddmax > 0, 'negative-mark' : compounding_result.back.ddmax < 0}">
                            {{ compounding_result.back.ddmax }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.back.web_profit > 0, 'negative-mark' : compounding_result.back.web_profit < 0}">
                            {{ compounding_result.back.web_profit.toFixed(2) }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.back.investimento > 0, 'negative-mark' : compounding_result.back.investimento < 0}">
                            {{ compounding_result.back.investimento.toFixed(2) }}
                        </td>
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.back.roi > 0, 'negative-mark' : compounding_result.back.roi < 0}">
                            {{ compounding_result.back.roi }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.back.roe > 0, 'negative-mark' : compounding_result.back.roe < 0}">
                            {{ compounding_result.back.roe }}
                        </td> 

                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.back.avg_odd > 0, 'negative-mark' : compounding_result.back.avg_odd < 0}">
                            {{ compounding_result.back.avg_odd }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.back.w_rate > 0, 'negative-mark' : compounding_result.back.w_rate < 0}">
                            {{ compounding_result.back.w_rate }}
                        </td> 
                    </tr>
                    <tr style="background: #b7eafc;">
                        <th class="dualHeader1" colspan="1">{{ $t("Lay (Payout)") }}</th>
                    </tr>
                    <tr style="background: #b7eafc;">
                        <th class="dualHeader1" colspan="1">{{ $t("Gross profit") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Gross loss") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Profit factor") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("DDMAX %") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Net Profit") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("investimento") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("ROI") }} (%)</th>
                        <th class="dualHeader1" colspan="1">{{ $t("ROE") }} (%)</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Avg Odd") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("W/Rate") }} (%)</th>
                    </tr>
                    <tr style="height: 33px;">
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_pay.gross_profit > 0, 'negative-mark' : compounding_result.lay_pay.gross_profit < 0}">
                            {{ compounding_result.lay_pay.gross_profit.toFixed(2) }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_pay.gross_loss > 0, 'negative-mark' : compounding_result.lay_pay.gross_loss < 0}">
                            {{ compounding_result.lay_pay.gross_loss.toFixed(2) }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_pay.profit_factor > 0, 'negative-mark' : compounding_result.lay_pay.profit_factor < 0}">
                            {{ compounding_result.lay_pay.profit_factor }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_pay.ddmax > 0, 'negative-mark' : compounding_result.lay_pay.ddmax < 0}">
                            {{ compounding_result.lay_pay.ddmax }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_pay.web_profit > 0, 'negative-mark' : compounding_result.lay_pay.web_profit < 0}">
                            {{ compounding_result.lay_pay.web_profit.toFixed(2) }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_pay.investimento > 0, 'negative-mark' : compounding_result.lay_pay.investimento < 0}">
                            {{ compounding_result.lay_pay.investimento.toFixed(2) }}
                        </td>
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_pay.roi > 0, 'negative-mark' : compounding_result.lay_pay.roi < 0}">
                            {{ compounding_result.lay_pay.roi }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_pay.roe > 0, 'negative-mark' : compounding_result.lay_pay.roe < 0}">
                            {{ compounding_result.lay_pay.roe }}
                        </td> 

                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_pay.avg_odd > 0, 'negative-mark' : compounding_result.lay_pay.avg_odd < 0}">
                            {{ compounding_result.lay_pay.avg_odd }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_pay.w_rate > 0, 'negative-mark' : compounding_result.lay_pay.w_rate < 0}">
                            {{ compounding_result.lay_pay.w_rate }}
                        </td> 
                    </tr>
                    <tr style="background: #b7eafc;">
                        <th class="dualHeader1" colspan="1">{{ $t("Lay (liability)") }}</th>
                    </tr>
                    <tr style="background: #b7eafc;">
                        <th class="dualHeader1" colspan="1">{{ $t("Gross profit") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Gross loss") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Profit factor") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("DDMAX %") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Net Profit") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("investimento") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("ROI") }} (%)</th>
                        <th class="dualHeader1" colspan="1">{{ $t("ROE") }} (%)</th>
                        <th class="dualHeader1" colspan="1">{{ $t("Avg Odd") }}</th>
                        <th class="dualHeader1" colspan="1">{{ $t("W/Rate") }} (%)</th>
                    </tr>
                    <tr style="height: 33px;">
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_lia.gross_profit > 0, 'negative-mark' : compounding_result.lay_lia.gross_profit < 0}">
                            {{ compounding_result.lay_lia.gross_profit.toFixed(2) }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_lia.gross_loss > 0, 'negative-mark' : compounding_result.lay_lia.gross_loss < 0}">
                            {{ compounding_result.lay_lia.gross_loss.toFixed(2) }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_lia.profit_factor > 0, 'negative-mark' : compounding_result.lay_lia.profit_factor < 0}">
                            {{ compounding_result.lay_lia.profit_factor }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_lia.ddmax > 0, 'negative-mark' : compounding_result.lay_lia.ddmax < 0}">
                            {{ compounding_result.lay_lia.ddmax }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_lia.web_profit > 0, 'negative-mark' : compounding_result.lay_lia.web_profit < 0}">
                            {{ compounding_result.lay_lia.web_profit.toFixed(2) }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_lia.investimento > 0, 'negative-mark' : compounding_result.lay_lia.investimento < 0}">
                            {{ compounding_result.lay_lia.investimento.toFixed(2) }}
                        </td>
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_lia.roi > 0, 'negative-mark' : compounding_result.lay_lia.roi < 0}">
                            {{ compounding_result.lay_lia.roi }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_lia.roe > 0, 'negative-mark' : compounding_result.lay_lia.roe < 0}">
                            {{ compounding_result.lay_lia.roe }}
                        </td> 

                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_lia.avg_odd > 0, 'negative-mark' : compounding_result.lay_lia.avg_odd < 0}">
                            {{ compounding_result.lay_lia.avg_odd }}
                        </td> 
                        <td style="padding: 0px" :class="{'positive-mark' : compounding_result.lay_lia.w_rate > 0, 'negative-mark' : compounding_result.lay_lia.w_rate < 0}">
                            {{ compounding_result.lay_lia.w_rate }}
                        </td> 
                    </tr>
                   
                </table>
            </CCol>
            <FinancialChart 
                :items="financialData_daily"
                :start_bankroll="parseInt(start_bankroll)"
            />
            <FinancialTable 
                :items="filteredData"
            />
            <FinancialLeagueTable 
                :items="filteredAllLeagueData"
                :title="$t('Operation by All leagues')"
            />

            <FinancialLeagueTable 
                :items="filteredLeagueData"
                :title="$t('Operation by single leagues')"
            />
        
        </CCard>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Swal from 'sweetalert2';

    import Avatar from '@/components/Avatar';

    import FinancialChart from '@/components/FinancialChart';
    import FinancialTable from '@/components/FinancialTable';
    import FinancialLeagueTable from '@/components/FinancialLeagueTable';

    import commonMixin from '@/mixins/common/commonMixin';
    import tipMixin from '@/mixins/TipMixin';
    import {capitalizeFL} from '@/helpers/string';
    import {displaySuccess} from '@/helpers/message';
    import {convertUTCToLocal, defaultFormat, defaultFormat2, getYear, getMonth, getDay, valueDate, labelDate } from '@/helpers/time';

    import Multiselect from 'vue-multiselect';

    export default {
        mixins: [commonMixin, tipMixin],
        components: {
            Avatar,            
            FinancialTable,
            FinancialChart,
            FinancialLeagueTable,
            Multiselect
        },
        data () {
            return {                
                fromDateOptions: [],
                toDateOptions: [],
                rankOptions: [
                    { value: "Home, Away", label: this.$t("Home, Away")},
                    { value: "Home", label: this.$t("Home")},
                    { value: "Away", label: this.$t("Away")},
                    { value: "Home OR Away", label: this.$t("Home OR Away")},
                    { value: "Home AND Away", label: this.$t("Home AND Away")},
                    { value: "Home > Away", label: this.$t("Home > Away")},
                    { value: "Home < Away", label: this.$t("Home < Away")},
                    { value: "Home = Away", label: this.$t("Home = Away")},
                    { value: "sum greater than", label: this.$t("sum greater than")},
                    { value: "sum minor than", label: this.$t("sum minor than")},
                    { value: "diff greater than", label: this.$t("diff greater than")},
                    { value: "diff minor than", label: this.$t("diff minor than")},
                    { value: "Away OR Away > Away OR Away", label: this.$t("Home OR Away > Home OR Away")},
                    { value: "", label: this.$t("None")}
                ],
                rankOption: "",
                rank_min: "",
                rank_max: "",
                leagueOptions: [
                    {
                      all: 'All leagues',
                      leagues: []
                    }
                ],
                leagueList: [],
                fromDate: "",
                toDate: "",
                data: [],
                userId: '',
                stat: {
                    userName: '',
                    total_tips: 0,
                    roi:  0,
                    profit_pts: 0,
                    w_rate: 0,
                    followers: '',
                    resetCount: 0,
                    description: '',
                    avg_odd: 0
                },
                total_stat: {
                    userName: '',
                    total_tips: 0,
                    roi:  0,
                    profit_pts: 0,
                    w_rate: 0,
                    followers: '',
                    resetCount: 0,
                    description: '',
                    avg_odd: 0
                },
                real_stat: {                    
                    total_tips: 0,
                    roi:  0,
                    profit_pts: 0,
                    w_rate: 0,
                    avg_odd: 0                   
                },
                strategy: {},
                notifications: [],
                stats1: [],
                stats2: [],
                userIsFollowed: false,
                strategyIsFollowed: false,

                back_inc: 3,
                lay_inc: 5,
                leverage_stake: 1,
                bf: 5,
                min_odd: 1,
                max_odd: 1000,
                swap_result: false,
                swap_odd: false,
                without_co: false,
                without_cover: false,
                tot_bets_filtered: 0,

                // lay_lia_points_1: "",
                // lay_lia_roi_1: "",
                // lay_lia_points_2: "",
                // lay_lia_roi_2: "",
                // lay_pay_points_1: "",
                // lay_pay_roi_1: "",
                // lay_pay_points_2: "",
                // lay_pay_roi_2: "",
                // back_points_1: "",
                // back_roi_1: "",
                // back_points_2: "",
                // back_roi_2: "",

                start_bankroll: 1000,
                compounding_size: 1,
                points_result: {
                    back: {
                        points: 0,
                        roi: 0,
                        avg_odd: 0,
                        w_rate: 0
                    },
                    lay_pay: {
                        points: 0,
                        roi: 0,
                        avg_odd: 0,
                        w_rate: 0
                    },
                    lay_lia: {
                       points: 0,
                        roi: 0,
                        avg_odd: 0,
                        w_rate: 0
                    }
                },
                leverage_result: {
                    back: {
                        points: 0,
                        roi: 0,
                        avg_odd: 0,
                        w_rate: 0
                    },
                    lay_pay: {
                        points: 0,
                        roi: 0,
                        avg_odd: 0,
                        w_rate: 0
                    },
                    lay_lia: {
                       points: 0,
                        roi: 0,
                        avg_odd: 0,
                        w_rate: 0
                    }
                },
                compounding_result: {
                    back: {
                        gross_profit: 0,
                        gross_loss: 0,
                        profit_factor: 0,
                        ddmax: 0,
                        web_profit: 0,
                        investimento: 0,
                        roi: 0,
                        roe: 0,
                        avg_odd: 0,
                        w_rate: 0
                    },
                    lay_pay: {
                        gross_profit: 0,
                        gross_loss: 0,
                        profit_factor: 0,
                        ddmax: 0,
                        web_profit: 0,
                        investimento: 0,
                        roi: 0,
                        roe: 0,
                        avg_odd: 0,
                        w_rate: 0
                    },
                    lay_lia: {
                        gross_profit: 0,
                        gross_loss: 0,
                        profit_factor: 0,
                        ddmax: 0,
                        web_profit: 0,
                        investimento: 0,
                        roi: 0,
                        roe: 0,
                        avg_odd: 0,
                        w_rate: 0
                    }
                },
                total_bets: [],
                financialData_daily: []
            }
        },
        computed: {
            ...mapGetters(['loggedInUser']),
            filteredData() {
                
                let back_inc = this.back_inc ? parseFloat(this.back_inc) : 0;
                let lay_inc = this.lay_inc ? parseFloat(this.lay_inc) : 0;
                let bf = this.bf ? parseFloat(this.bf) : 0;

                let start_bankroll = this.start_bankroll ? parseFloat(this.start_bankroll) : 0;
                let compounding_size = this.compounding_size ? parseFloat(this.compounding_size) : 0;
                let leverage_stake = this.leverage_stake ? parseFloat(this.leverage_stake) : 0;

                let max_comp_back_cur_bank = start_bankroll;
                let max_comp_pay_cur_bank = start_bankroll;
                let max_comp_lia_cur_bank = start_bankroll;

                let orig_bets = [...this.total_bets];
                let total_bets = [];

                let min_odd = 0;
                let max_odd = 1000;
                if ( this.min_odd )
                    min_odd = parseFloat(this.min_odd);
                if ( this.max_odd )
                    max_odd = parseFloat(this.max_odd);

                let points_result = {
                    back: {
                        points: 0,
                        roi: 0,
                        avg_odd: 0,
                        w_rate: 0,
                        total_stake: 0
                    },
                    lay_pay: {
                        points: 0,
                        roi: 0,
                        avg_odd: 0,
                        w_rate: 0,
                        total_stake: 0
                    },
                    lay_lia: {
                       points: 0,
                        roi: 0,
                        avg_odd: 0,
                        w_rate: 0,
                        total_stake: 0
                    }
                };
                let leverage_result = {
                    back: {
                        points: 0,
                        roi: 0,
                        avg_odd: 0,
                        w_rate: 0,
                        total_stake: 0
                    },
                    lay_pay: {
                        points: 0,
                        roi: 0,
                        avg_odd: 0,
                        w_rate: 0,
                        total_stake: 0
                    },
                    lay_lia: {
                        points: 0,
                        roi: 0,
                        avg_odd: 0,
                        w_rate: 0,
                        total_stake: 0
                    }
                };

                let compounding_result = {
                    back: {
                        gross_profit: 0,
                        gross_loss: 0,
                        profit_factor: 0,
                        ddmax: 0,
                        web_profit: 0,
                        investimento: 0,
                        roi: 0,
                        roe: 0,
                        avg_odd: 0,
                        w_rate: 0
                    },
                    lay_pay: {
                        gross_profit: 0,
                        gross_loss: 0,
                        profit_factor: 0,
                        ddmax: 0,
                        web_profit: 0,
                        investimento: 0,
                        roi: 0,
                        roe: 0,
                        avg_odd: 0,
                        w_rate: 0
                    },
                    lay_lia: {
                        gross_profit: 0,
                        gross_loss: 0,
                        profit_factor: 0,
                        ddmax: 0,
                        web_profit: 0,
                        investimento: 0,
                        roi: 0,
                        roe: 0,
                        avg_odd: 0,
                        w_rate: 0
                    }
                };

                let tip_count = 0;
                let back_odd_filtered = 0;
                let lay_odd_filtered = 0;

                let total_points_back = 0;
                let total_points_payout = 0;
                let total_points_liability = 0;
                let total_stake_back = 0;
                let total_stake_payout = 0;
                let total_stake_liability = 0;

                let tot_bets_filtered = 0;

                
                let financialData_daily = [];
                let old_year = null;
                let old_month = null;
                let old_day = null;

                let old_back = null;
                let old_layPayout = null;
                let old_layLiability = null;

                let filter_leagues = this.leagueList.map(({country_league})=>country_league);
                for ( var i = 0; i < orig_bets.length; i++) {
                        let one_bet = {...orig_bets[i]};
                        if (this.without_cover && one_bet["tipORcover"] == this.$t("cover"))
                            continue;

                        let dateTime = convertUTCToLocal(one_bet["Post Date"], (new Date()).getTimezoneOffset() / 60);
                        one_bet["Post Date"] = defaultFormat2( dateTime );

                        let cur_year = getYear( dateTime );
                        let cur_month = getMonth( dateTime );
                        let cur_day = getDay( dateTime );

                        let bet_365_entry = one_bet["Bet 365 Entry"];
                        if ( this.swap_odd ) {
                            one_bet["Bet 365 Entry"] = parseFloat((100 / ( 100 - ( 100 / one_bet["Bet 365 Entry"] ) )).toFixed(2)); 
                        }

                        if ( one_bet["Bet 365 Entry"] < min_odd || one_bet["Bet 365 Entry"] >= max_odd ) {
                            if ( i == (orig_bets.length -1) && old_back && old_layPayout && old_layLiability) {
                                financialData_daily.push({
                                    year: old_year,
                                    month: old_month,
                                    day: old_day,
                                    back: old_back,
                                    lay_payout: old_layPayout,
                                    lay_liability: old_layLiability
                                });
                            }
                            continue;
                        }

                        if ( one_bet["value_date"] < this.fromDate || one_bet["value_date"] > this.toDate ) {
                            if ( i == (orig_bets.length -1) && old_back && old_layPayout && old_layLiability) {
                                financialData_daily.push({
                                    year: old_year,
                                    month: old_month,
                                    day: old_day,
                                    back: old_back,
                                    lay_payout: old_layPayout,
                                    lay_liability: old_layLiability
                                });
                            }
                            continue;
                        }

                        if ( filter_leagues.length > 0 ) {
                            if ( !filter_leagues.includes(one_bet["country_league"]) )
                                continue;

                        }
                        
                        if ( this.rankOption != "" ) {
                            let check_rankFilter = this.check_one_filter(this.rankOption, this.rank_min, this.rank_max, one_bet["home_rank"], one_bet["away_rank"])
                            if (!check_rankFilter)
                                continue;
                        }

                        

                        if (this.without_co)
                            one_bet["Cash out"] = "No";

                        
                        one_bet["entry_back_odd"] = parseFloat((one_bet["Bet 365 Entry"] * ( 1 + back_inc / 100)).toFixed(2));
                        one_bet["entry_lay_odd"] = parseFloat((one_bet["Bet 365 Entry"] * ( 1 + lay_inc / 100)).toFixed(2));

                        // if (one_bet["entry_back_odd"] == 1)
                        //     one_bet["entry_back_odd"] = 1.01;
                        // if (one_bet["entry_lay_odd"] == 1)
                        //     one_bet["entry_lay_odd"] = 1.01;

                        if ( one_bet["Cash out"] == "Yes" && one_bet["Bet 365 CO Odds"] ) {
                            if ( this.swap_odd ) {
                                one_bet["Bet 365 CO Odds"] = parseFloat((100 / ( 100 - ( 100 / one_bet["Bet 365 CO Odds"] ) )).toFixed(2)); 
                            }
                            one_bet["cashout_back_odd"] = parseFloat((one_bet["Bet 365 CO Odds"] * ( 1 + back_inc / 100)).toFixed(2));
                            one_bet["cashout_lay_odd"] = parseFloat((one_bet["Bet 365 CO Odds"] * ( 1 + back_inc / 100)).toFixed(2));
                        }
                        else {
                            one_bet["cashout_back_odd"] = "";
                            one_bet["cashout_lay_odd"] = "";
                        }

                        if (one_bet["cashout_back_odd"] == 1)
                            one_bet["cashout_back_odd"] = 1.01;
                        if (one_bet["cashout_lay_odd"] == 1)
                            one_bet["cashout_lay_odd"] = 1.01;

                        if ( one_bet["Cash out"] == "Yes" ){
                            if (one_bet["Bet 365 Entry"] > one_bet["Bet 365 CO Odds"])
                                one_bet["outcome"] = "V";
                            else
                                one_bet["outcome"] = "F";
                        }
                        else {
                            if ( this.swap_result ) {
                                if ( one_bet["real Outcome"] == "V")
                                    one_bet["outcome"] = "F";
                                else
                                    one_bet["outcome"] = "V";
                            }
                            else
                                one_bet["outcome"] = one_bet["real Outcome"];
                            
                        }

                        one_bet["Lay Risk"] = parseFloat((one_bet["stake"] * one_bet["entry_lay_odd"] - one_bet["stake"]).toFixed(2));

                        // P/L compounding => Stake Back, stake lay, liab stake
                        if ( tip_count == 0) {
                            one_bet["comp_back_stake_back"] = parseFloat(( start_bankroll  *  compounding_size/100 ).toFixed(2));

                            one_bet["comp_pay_stake_lay"] = parseFloat(( start_bankroll  *  compounding_size/100 ).toFixed(2));

                            one_bet["comp_lia_stake_lay"] = parseFloat(( (start_bankroll * compounding_size/100 ) / ( 1 / ( 100 / one_bet["entry_lay_odd"] / 100 ) - 1) ).toFixed(2));

                        }
                        else {
                            if ( total_bets[tip_count-1]["outcome"] == "V" || total_bets[tip_count-1]["outcome"] == 0 ) {
                                one_bet["comp_back_stake_back"] = parseFloat(( total_bets[tip_count-1]["comp_back_cur_bank"] * ( 1 + compounding_size/100 ) - total_bets[tip_count-1]["comp_back_cur_bank"]).toFixed(2));
                                
                            }
                            else {
                                one_bet["comp_back_stake_back"] = parseFloat(( total_bets[tip_count-1]["comp_back_cur_bank"] * compounding_size/100 ).toFixed(2));                               
                            }
                            one_bet["comp_pay_stake_lay"] =  parseFloat(( total_bets[tip_count-1]["comp_pay_cur_bank"] * compounding_size/100 ).toFixed(2));
                            one_bet["comp_lia_stake_lay"] = parseFloat(( (total_bets[tip_count-1]["comp_lia_cur_bank"] * compounding_size/100 ) / ( 1 / ( 100 / one_bet["entry_lay_odd"] / 100 ) - 1) ).toFixed(2));
                        }
                        
                        // points_back
                        one_bet["points_liab_stake"] = parseFloat((one_bet["stake"] / ( 1 / ( 100 / one_bet["entry_lay_odd"] / 100 ) - 1 )).toFixed(2));
                        one_bet["points_liab_risk"] = parseFloat((one_bet["points_liab_stake"] * one_bet["entry_lay_odd"] - one_bet["points_liab_stake"]).toFixed(2));

                        // Compounding => lay Payout => lay risk
                        one_bet["comp_pay_risk"] = parseFloat(( one_bet["comp_pay_stake_lay"] * one_bet["entry_lay_odd"] - one_bet["comp_pay_stake_lay"] ).toFixed(2));

                        if ( one_bet["Cash out"] == "Yes" ) {
                            if ( one_bet["outcome"] == "F" ) {
                                one_bet["points_back"] = parseFloat(((one_bet["stake"] * one_bet["entry_back_odd"] / one_bet["cashout_lay_odd"] - one_bet["stake"]) * ( 1 - bf / 100 )).toFixed(2));
                                one_bet["points_payout"] = parseFloat((( one_bet["stake"] - one_bet["stake"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"]) * ( 1 - bf / 100 )).toFixed(2));
                                one_bet["points_liability"] = parseFloat(((one_bet["points_liab_stake"] - one_bet["points_liab_stake"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"]) * ( 1 - bf / 100 )).toFixed(2));

                                // P/L compounding => Back
                                one_bet["comp_back"] = parseFloat((one_bet["comp_back_stake_back"] * one_bet["entry_back_odd"] / one_bet["cashout_lay_odd"] - one_bet["comp_back_stake_back"]).toFixed(2));

                                // P/L compounding => Lay => Payout
                                one_bet["comp_payout"] = parseFloat((( one_bet["comp_pay_stake_lay"] - one_bet["comp_pay_stake_lay"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"] ) * ( 1 - bf / 100 )).toFixed(2));

                                // P/L compounding => Lay => Liability
                                one_bet["comp_liability"] = parseFloat((( one_bet["comp_lia_stake_lay"] - one_bet["comp_lia_stake_lay"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"] ) * ( 1 - bf / 100 )).toFixed(2));

                                // P/L Leverage stake
                                one_bet["stake_back"] = parseFloat((one_bet["stake"] * leverage_stake * one_bet["entry_back_odd"] / one_bet["cashout_lay_odd"] - one_bet["stake"] * leverage_stake).toFixed(2));
                                one_bet["stake_payout"] = parseFloat((one_bet["stake"] * leverage_stake - ((one_bet["stake"] * leverage_stake) * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"]) * ( 1 - bf / 100 ) ).toFixed(2));
                                one_bet["stake_liability"] = parseFloat((one_bet["points_liab_stake"] * leverage_stake - ((one_bet["points_liab_stake"] * leverage_stake) * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"]) * ( 1 - bf / 100 ) ).toFixed(2));

                            }
                            else {
                                one_bet["points_back"] = parseFloat((one_bet["stake"] * one_bet["entry_back_odd"] / one_bet["cashout_lay_odd"] - one_bet["stake"]).toFixed(2));
                                one_bet["points_payout"] = parseFloat(( one_bet["stake"] - one_bet["stake"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"] ).toFixed(2));
                                one_bet["points_liability"] = parseFloat((one_bet["points_liab_stake"] - one_bet["points_liab_stake"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"]).toFixed(2));

                                // P/L compounding => Back
                                one_bet["comp_back"] = parseFloat(((one_bet["comp_back_stake_back"] * one_bet["entry_back_odd"] / one_bet["cashout_lay_odd"] - one_bet["comp_back_stake_back"]) * ( 1 - bf / 100 )).toFixed(2));

                                // P/L compounding => Lay => Payout
                                one_bet["comp_payout"] = parseFloat((one_bet["comp_pay_stake_lay"] - one_bet["comp_pay_stake_lay"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"] ).toFixed(2));

                                // P/L compounding => Lay => Liability
                                one_bet["comp_liability"] = parseFloat(( one_bet["comp_lia_stake_lay"] - one_bet["comp_lia_stake_lay"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"] ).toFixed(2));

                                // P/L Leverage stake
                                one_bet["stake_back"] = parseFloat((one_bet["stake"] * leverage_stake * one_bet["entry_back_odd"] / one_bet["cashout_lay_odd"] - one_bet["stake"] * leverage_stake).toFixed(2));
                                one_bet["stake_payout"] = parseFloat((one_bet["stake"] * leverage_stake - ((one_bet["stake"] * leverage_stake) * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"]) ).toFixed(2));
                                one_bet["stake_liability"] = parseFloat((one_bet["points_liab_stake"] * leverage_stake - ((one_bet["points_liab_stake"] * leverage_stake) * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"]) ).toFixed(2));
                            }
                        }
                        else {
                            if ( one_bet["outcome"] == "V" ) {

                                one_bet["points_back"] = parseFloat(((one_bet["stake"] * one_bet["entry_back_odd"] - one_bet["stake"]) * ( 1 - bf / 100 )).toFixed(2));

                                one_bet["points_payout"] = parseFloat(( one_bet["stake"] - one_bet["stake"] * one_bet["entry_lay_odd"]).toFixed(2));
                                one_bet["points_liability"] = parseFloat((one_bet["points_liab_stake"] - one_bet["points_liab_stake"] * one_bet["entry_lay_odd"] ).toFixed(2));

                                // P/L compounding => Back
                                one_bet["comp_back"] = parseFloat(((one_bet["comp_back_stake_back"] * one_bet["entry_back_odd"] - one_bet["comp_back_stake_back"]) * ( 1 - bf / 100 )).toFixed(2));

                                // P/L compounding => Lay => Payout
                                one_bet["comp_payout"] = parseFloat((one_bet["comp_pay_stake_lay"] - one_bet["comp_pay_stake_lay"] * one_bet["entry_lay_odd"] ).toFixed(2));

                                // P/L compounding => Lay => Liability
                                one_bet["comp_liability"] = parseFloat((one_bet["comp_lia_stake_lay"] - one_bet["comp_lia_stake_lay"] * one_bet["entry_lay_odd"] ).toFixed(2));

                                // P/L Leverage stake
                                one_bet["stake_back"] = parseFloat((one_bet["stake"] * leverage_stake * one_bet["entry_back_odd"]  - one_bet["stake"] * leverage_stake).toFixed(2));
                                one_bet["stake_payout"] = parseFloat((one_bet["stake"] * leverage_stake - (one_bet["stake"] * leverage_stake * one_bet["entry_lay_odd"] ) ).toFixed(2));
                                one_bet["stake_liability"] = parseFloat((one_bet["points_liab_stake"] * leverage_stake - one_bet["points_liab_stake"] * leverage_stake * one_bet["entry_lay_odd"] ).toFixed(2));
                            }
                            else {
                                one_bet["points_back"] = parseFloat((one_bet["stake"] * -1).toFixed(2));
                                one_bet["points_payout"] = parseFloat((one_bet["stake"] * ( 1 - bf / 100 )).toFixed(2));
                                one_bet["points_liability"] = parseFloat((one_bet["points_liab_stake"] * ( 1 - bf / 100 )).toFixed(2));

                                // P/L compounding => Back
                                one_bet["comp_back"] = parseFloat((one_bet["comp_back_stake_back"] * -1).toFixed(2));

                                // P/L compounding => Lay => Payout
                                one_bet["comp_payout"] = parseFloat(( one_bet["comp_pay_stake_lay"]  * ( 1 - bf / 100 )).toFixed(2));

                                // P/L compounding => Lay => Liability
                                one_bet["comp_liability"] = parseFloat(( one_bet["comp_lia_stake_lay"]  * ( 1 - bf / 100 )).toFixed(2));

                                // P/L Leverage stake
                                one_bet["stake_back"] = parseFloat(( -1 * one_bet["stake"] * leverage_stake).toFixed(2));
                                one_bet["stake_payout"] = parseFloat((one_bet["stake"] * leverage_stake * ( 1 - bf / 100 ) ).toFixed(2));
                                one_bet["stake_liability"] = parseFloat((one_bet["points_liab_stake"] * leverage_stake * ( 1 - bf / 100 ) ).toFixed(2));
                            }
                        }

                        // in case odds is 1
                        if (one_bet["entry_back_odd"] == 1 || one_bet["entry_lay_odd"] == 1) {
                            one_bet["points_back"] = 0;
                            one_bet["points_payout"] = 0;
                            one_bet["points_liability"] = 0;
                            one_bet["stake_back"] = 0;
                            one_bet["stake_payout"] = 0;
                            one_bet["stake_liability"] = 0;
                            one_bet["comp_back"] = 0;
                            one_bet["comp_payout"] = 0;
                            one_bet["comp_liability"] = 0;
                            one_bet["comp_lia_stake_lay"] = 0;
                            
                        }

                        // P/L compounding => Back => current Bank
                        // P/L compounding => Lay(payout) => current Bank
                        if ( tip_count == 0) {
                            one_bet["comp_back_cur_bank"] = parseFloat(( one_bet["comp_back"] + start_bankroll ).toFixed(2));
                            if ( one_bet["comp_back_cur_bank"] < max_comp_back_cur_bank )
                                one_bet["comp_back_draw_down"] = parseFloat(( one_bet["comp_back"] / max_comp_back_cur_bank * 100 ).toFixed(2));
                            else
                                one_bet["comp_back_draw_down"] = 0;

                            one_bet["comp_pay_cur_bank"] = parseFloat(( one_bet["comp_payout"] + start_bankroll ).toFixed(2));
                            if ( one_bet["comp_pay_cur_bank"] < max_comp_pay_cur_bank )
                                one_bet["comp_pay_draw_down"] = parseFloat(( one_bet["comp_payout"] / max_comp_pay_cur_bank * 100 ).toFixed(2));
                            else
                                one_bet["comp_pay_draw_down"] = 0;

                            one_bet["comp_lia_cur_bank"] = parseFloat(( one_bet["comp_liability"] + start_bankroll ).toFixed(2));
                            if ( one_bet["comp_lia_cur_bank"] < max_comp_lia_cur_bank )
                                one_bet["comp_lia_draw_down"] = parseFloat(( one_bet["comp_liability"] / max_comp_lia_cur_bank * 100 ).toFixed(2));
                            else
                                one_bet["comp_lia_draw_down"] = 0;

                        }
                        else {
                            one_bet["comp_back_cur_bank"] = parseFloat(( one_bet["comp_back"] + total_bets[tip_count-1]["comp_back_cur_bank"] ).toFixed(2));
                            max_comp_back_cur_bank = Math.max(max_comp_back_cur_bank, total_bets[tip_count-1]["comp_back_cur_bank"]);
                            if ( one_bet["comp_back_cur_bank"] < max_comp_back_cur_bank )
                                one_bet["comp_back_draw_down"] = parseFloat(( one_bet["comp_back"] / max_comp_back_cur_bank * 100 + total_bets[tip_count-1]["comp_back_draw_down"] ).toFixed(2));
                            else
                                one_bet["comp_back_draw_down"] = 0;

                            one_bet["comp_pay_cur_bank"] = parseFloat(( one_bet["comp_payout"] + total_bets[tip_count-1]["comp_pay_cur_bank"] ).toFixed(2));
                            max_comp_pay_cur_bank = Math.max(max_comp_pay_cur_bank, total_bets[tip_count-1]["comp_pay_cur_bank"]);
                            if ( one_bet["comp_pay_cur_bank"] < max_comp_pay_cur_bank )
                                one_bet["comp_pay_draw_down"] = parseFloat(( one_bet["comp_payout"] / max_comp_pay_cur_bank * 100 + total_bets[tip_count-1]["comp_pay_draw_down"] ).toFixed(2));
                            else
                                one_bet["comp_pay_draw_down"] = 0;

                            one_bet["comp_lia_cur_bank"] = parseFloat(( one_bet["comp_liability"] + total_bets[tip_count-1]["comp_lia_cur_bank"] ).toFixed(2));
                            max_comp_lia_cur_bank = Math.max(max_comp_lia_cur_bank, total_bets[tip_count-1]["comp_lia_cur_bank"]);
                            if ( one_bet["comp_lia_cur_bank"] < max_comp_lia_cur_bank )
                                one_bet["comp_lia_draw_down"] = parseFloat(( one_bet["comp_liability"] / max_comp_lia_cur_bank * 100 + total_bets[tip_count-1]["comp_lia_draw_down"] ).toFixed(2));
                            else
                                one_bet["comp_lia_draw_down"] = 0;
                        }

                        // if current bank is negative value, set to 0
                        if ( one_bet["comp_back_cur_bank"] < 0 )
                            one_bet["comp_back_cur_bank"] = 0;
                        if ( one_bet["comp_pay_cur_bank"] < 0 )
                            one_bet["comp_pay_cur_bank"] = 0;
                        if ( one_bet["comp_lia_cur_bank"] < 0 )
                            one_bet["comp_lia_cur_bank"] = 0;

                        total_bets.push(one_bet);
                        

                        if ( one_bet["value_date"] >= this.fromDate && one_bet["value_date"] <= this.toDate && one_bet["Bet 365 Entry"] >=min_odd && one_bet["Bet 365 Entry"] < max_odd) {



                            // calculate compounding
                            total_points_back       += one_bet["points_back"];
                            total_points_payout     += one_bet["points_payout"];
                            total_points_liability  += one_bet["points_liability"];
                            total_stake_back        += one_bet["stake_back"];
                            total_stake_payout      += one_bet["stake_payout"];
                            total_stake_liability   += one_bet["stake_liability"];

                            // if (  one_bet["entry_back_odd"] >= min_odd && one_bet["entry_back_odd"] < max_odd ){
                                // if ( one_bet["comp_back"] > 0) {
                                if ( one_bet["comp_back"] > 0) {
                                    compounding_result.back.gross_profit += one_bet["comp_back"];
                                    
                                }
                                if ( one_bet["comp_back"] < 0)
                                    compounding_result.back.gross_loss += one_bet["comp_back"];

                                if ( one_bet["outcome"] == "V") {
                                    compounding_result.back.w_rate += 1;
                                }

                                if ( tip_count == 0 )
                                    compounding_result.back.ddmax = one_bet["comp_back_draw_down"];
                                else if ( one_bet["comp_back_draw_down"] < compounding_result.back.ddmax)
                                    compounding_result.back.ddmax = one_bet["comp_back_draw_down"];
                                
                                compounding_result.back.web_profit += one_bet["comp_back"];
                                compounding_result.back.investimento += one_bet["comp_back_stake_back"];
                                compounding_result.back.avg_odd += one_bet["entry_back_odd"];

                                back_odd_filtered += 1;

                                // points table
                                points_result.back.points += one_bet["points_back"];
                                
                                // leverage table
                                leverage_result.back.points += one_bet["stake_back"];

                                // stake sum
                                points_result.back.total_stake += one_bet["stake"];
                                if (leverage_stake)
                                    leverage_result.back.total_stake += one_bet["stake"] *  leverage_stake;
                                else
                                    leverage_result.back.total_stake += one_bet["stake"];
                                
                            // }

                            // if (  one_bet["entry_lay_odd"] >= min_odd && one_bet["entry_lay_odd"] < max_odd ){
                                if ( one_bet["comp_payout"] > 0) {
                                    compounding_result.lay_pay.gross_profit += one_bet["comp_payout"];
                                    
                                }
                                if ( one_bet["comp_payout"] < 0)
                                    compounding_result.lay_pay.gross_loss += one_bet["comp_payout"];

                                if ( one_bet["outcome"] == "F") {
                                    compounding_result.lay_pay.w_rate += 1;
                                    compounding_result.lay_lia.w_rate += 1;
                                }
                                if ( tip_count == 0 )
                                    compounding_result.lay_pay.ddmax = one_bet["comp_pay_draw_down"];
                                else if ( one_bet["comp_pay_draw_down"] < compounding_result.lay_pay.ddmax)
                                    compounding_result.lay_pay.ddmax = one_bet["comp_pay_draw_down"];
                                
                                compounding_result.lay_pay.web_profit += one_bet["comp_payout"];
                                compounding_result.lay_pay.investimento += one_bet["comp_pay_stake_lay"];
                                compounding_result.lay_pay.avg_odd += one_bet["entry_lay_odd"];

                                if ( one_bet["comp_liability"] > 0) {
                                    compounding_result.lay_lia.gross_profit += one_bet["comp_liability"];                                
                                }
                                if ( one_bet["comp_liability"] < 0)
                                    compounding_result.lay_lia.gross_loss += one_bet["comp_liability"];
                                if ( tip_count == 0 )
                                    compounding_result.lay_lia.ddmax = one_bet["comp_lia_draw_down"];
                                else if ( one_bet["comp_lia_draw_down"] < compounding_result.lay_lia.ddmax)
                                    compounding_result.lay_lia.ddmax = one_bet["comp_lia_draw_down"];
                                
                                compounding_result.lay_lia.web_profit += one_bet["comp_liability"];
                                compounding_result.lay_lia.investimento += one_bet["comp_lia_stake_lay"];
                                compounding_result.lay_lia.avg_odd += one_bet["entry_lay_odd"];

                                lay_odd_filtered += 1;

                                // points table
                                points_result.lay_pay.points += one_bet["points_payout"];
                                points_result.lay_lia.points += one_bet["points_liability"];

                                // leverage table                            
                                leverage_result.lay_pay.points += one_bet["stake_payout"];
                                leverage_result.lay_lia.points += one_bet["stake_liability"];

                                // stake sum
                                points_result.lay_pay.total_stake += one_bet["stake"];
                                points_result.lay_lia.total_stake += one_bet["stake"];
                                if (leverage_stake) {
                                    leverage_result.lay_pay.total_stake += one_bet["stake"] *  leverage_stake;
                                    leverage_result.lay_lia.total_stake += one_bet["stake"] *  leverage_stake;
                                }
                                else{
                                    leverage_result.lay_pay.total_stake += one_bet["stake"];
                                    leverage_result.lay_lia.total_stake += one_bet["stake"];
                                }
                            // }

                            

                            // if ( one_bet["entry_lay_odd"] >= min_odd && one_bet["entry_lay_odd"] < max_odd )
                            tot_bets_filtered += 1;

                            // for financial chart                            

                            if ( old_year && old_month && old_day ){
                                if ( old_year != cur_year || old_month != cur_month || old_day != cur_day ){
                                    financialData_daily.push({
                                        year: old_year,
                                        month: old_month,
                                        day: old_day,
                                        back: old_back,
                                        lay_payout: old_layPayout,
                                        lay_liability: old_layLiability
                                    });
                                }
                                if ( i ==  (orig_bets.length - 1) ) {
                                    financialData_daily.push({
                                        year: cur_year,
                                        month: cur_month,
                                        day: cur_day,
                                        back: one_bet["comp_back_cur_bank"],
                                        lay_payout: one_bet["comp_pay_cur_bank"],
                                        lay_liability: one_bet["comp_lia_cur_bank"]
                                    });
                                }
                            }

                            old_year = cur_year;
                            old_month = cur_month;
                            old_day = cur_day;
                            old_back = one_bet["comp_back_cur_bank"];
                            old_layPayout = one_bet["comp_pay_cur_bank"];
                            old_layLiability = one_bet["comp_lia_cur_bank"];
                        }

                        tip_count += 1;

                }

                if ( compounding_result.back.gross_loss != 0 ){
                    compounding_result.back.profit_factor = Math.abs(compounding_result.back.gross_profit / compounding_result.back.gross_loss).toFixed(2);
                }
                if ( compounding_result.back.investimento != 0 ){
                    compounding_result.back.roi = (100 * compounding_result.back.web_profit / compounding_result.back.investimento).toFixed(2);
                }
                if ( compounding_result.lay_pay.gross_loss != 0 ){
                    compounding_result.lay_pay.profit_factor = Math.abs(compounding_result.lay_pay.gross_profit / compounding_result.lay_pay.gross_loss).toFixed(2);
                }
                if ( compounding_result.lay_pay.investimento != 0 ){
                    compounding_result.lay_pay.roi = (100 * compounding_result.lay_pay.web_profit / compounding_result.lay_pay.investimento).toFixed(2);
                }
                if ( compounding_result.lay_lia.gross_loss != 0 ){
                    compounding_result.lay_lia.profit_factor = Math.abs(compounding_result.lay_lia.gross_profit / compounding_result.lay_lia.gross_loss).toFixed(2);
                }
                if ( compounding_result.lay_lia.investimento != 0 ){
                    compounding_result.lay_lia.roi = (100 * compounding_result.lay_lia.web_profit / compounding_result.lay_lia.investimento).toFixed(2);
                }
                if (this.start_bankroll) {
                    compounding_result.back.roe = (100 * compounding_result.back.web_profit / parseFloat(this.start_bankroll)).toFixed(2);
                    compounding_result.lay_pay.roe = (100 * compounding_result.lay_pay.web_profit / parseFloat(this.start_bankroll)).toFixed(2);
                    compounding_result.lay_lia.roe = (100 * compounding_result.lay_lia.web_profit / parseFloat(this.start_bankroll)).toFixed(2);
                }
                if (back_odd_filtered > 0) {
                    compounding_result.back.avg_odd = (compounding_result.back.avg_odd / back_odd_filtered).toFixed(2);
                    compounding_result.back.w_rate = (compounding_result.back.w_rate / back_odd_filtered * 100).toFixed(2);
                }
                if (lay_odd_filtered > 0) {
                    compounding_result.lay_pay.avg_odd = (compounding_result.lay_pay.avg_odd / lay_odd_filtered).toFixed(2);
                    compounding_result.lay_pay.w_rate = (compounding_result.lay_pay.w_rate / lay_odd_filtered  * 100).toFixed(2);

                    compounding_result.lay_lia.avg_odd = (compounding_result.lay_lia.avg_odd / lay_odd_filtered).toFixed(2);
                    compounding_result.lay_lia.w_rate = (compounding_result.lay_lia.w_rate / lay_odd_filtered  * 100).toFixed(2);
                }

               
                // calculate points, leverage

                if ( total_points_liability < 0 )
                    points_result.lay_lia.points = total_points_liability;
                if ( total_points_payout < 0 )
                    points_result.lay_pay.points = total_points_payout;
                if ( total_stake_liability < 0 )
                    leverage_result.lay_lia.points = total_stake_liability;
                if ( total_stake_payout < 0 )
                    leverage_result.lay_pay.points = total_stake_payout;

                if (points_result.back.total_stake != 0){
                    points_result.back.roi = parseFloat((100 * points_result.back.points / points_result.back.total_stake).toFixed(2));
                }

                if (points_result.lay_pay.total_stake != 0){
                    points_result.lay_pay.roi = parseFloat((100 * points_result.lay_pay.points / points_result.lay_pay.total_stake).toFixed(2));
                    points_result.lay_lia.roi = parseFloat((100 * points_result.lay_lia.points / points_result.lay_lia.total_stake).toFixed(2));
                }

                if (leverage_result.back.total_stake != 0){
                    leverage_result.back.roi = parseFloat((100 * leverage_result.back.points / leverage_result.back.total_stake).toFixed(2));
                }

                if (leverage_result.lay_pay.total_stake != 0){
                    leverage_result.lay_pay.roi = parseFloat((100 * leverage_result.lay_pay.points / leverage_result.lay_pay.total_stake).toFixed(2));
                    leverage_result.lay_lia.roi = parseFloat((100 * leverage_result.lay_lia.points / leverage_result.lay_lia.total_stake).toFixed(2));
                }

                // new leverage
                leverage_result = {
                    back: {
                        points: (leverage_stake * points_result.back.points).toFixed(2) ,
                        roi: points_result.back.roi,
                        avg_odd: 0,
                        w_rate: 0,
                        total_stake: 0
                    },
                    lay_pay: {
                        points: (leverage_stake * points_result.lay_pay.points).toFixed(2) ,
                        roi: points_result.lay_pay.roi,
                        avg_odd: 0,
                        w_rate: 0,
                        total_stake: 0
                    },
                    lay_lia: {
                        points: (leverage_stake * points_result.lay_lia.points).toFixed(2) ,
                        roi: points_result.lay_lia.roi,
                        avg_odd: 0,
                        w_rate: 0,
                        total_stake: 0
                    }
                };

                points_result.back.points = points_result.back.points.toFixed(2);
                points_result.lay_lia.points = points_result.lay_lia.points.toFixed(2);
                points_result.lay_pay.points = points_result.lay_pay.points.toFixed(2);
                // leverage_result.back.points = leverage_result.back.points.toFixed(2);
                // leverage_result.lay_lia.points = leverage_result.lay_lia.points.toFixed(2);
                // leverage_result.lay_pay.points = leverage_result.lay_pay.points.toFixed(2);

                
                this.points_result = points_result;
                this.leverage_result = leverage_result;
                this.compounding_result = compounding_result;                

                this.financialData_daily = financialData_daily;                

                this.sortJSON1(total_bets, "index");
                
                total_bets = total_bets.filter( dItem => dItem.value_date >= this.fromDate && dItem.value_date <= this.toDate && dItem["Bet 365 Entry"] >= min_odd && dItem["Bet 365 Entry"] < max_odd);
                this.tot_bets_filtered = total_bets.length;
                return total_bets;


            },
            filteredLeagueData() {
                let result = [];
                let  country_league_list = this.filteredData.map(({ country_league }) => country_league);
                country_league_list = [...new Set(country_league_list)];
                country_league_list.sort();

                for ( let i = 0; i < country_league_list.length; i++ ) {
                    let country_league = country_league_list[i];
                    let league_tips = this.filteredData.filter( item => item.country_league == country_league );
                    if ( league_tips.length > 0 ) {
                        let tips_len = league_tips.length;

                        let cashout_len = 0;

                        let win_bets = 0;
                        let loss_bets = 0;
                        let win_rows = 0;
                        let loss_rows = 0;

                        let total_entry = 0;
                        let total_cashout = 0;
                        let entry_back_odd = 0;
                        let entry_lay_odd = 0;
                        let cashout_back_odd = 0;
                        let cashout_lay_odd = 0;

                        let win_repeat = 0;
                        let loss_repeat = 0;

                        let max_win_repeat = 0;
                        let max_loss_repeat = 0;

                        let recent_max_win_repeat = 0;
                        let recent_max_loss_repeat = 0;
                        let recent_win_flag = true;
                        let recent_loss_flag = true;

                        let total_profits = 0;
                        let total_losses = 0;

                        let outcome_string = "";

                        for ( var j=0; j<league_tips.length; j++) {
                            let league_tip = league_tips[j];
                            total_entry += league_tip["Bet 365 Entry"];
                            entry_back_odd += league_tip["entry_back_odd"];
                            entry_lay_odd += league_tip["entry_lay_odd"];

                            outcome_string += league_tip["outcome"];
                            if (league_tip["outcome"] == "V")
                                win_bets += 1;
                            else
                                loss_bets += 1;
                            if (league_tip["Bet 365 CO Odds"] != ""){
                                cashout_len += 1;
                                total_cashout += league_tip["Bet 365 CO Odds"];
                                cashout_back_odd += league_tip["cashout_back_odd"];
                                cashout_lay_odd += league_tip["cashout_lay_odd"];
                            }

                            if ( j == 0 ){
                                if (league_tip["outcome"] == "V" ){
                                    win_repeat += 1;
                                    max_win_repeat += 1;
                                    recent_max_win_repeat += 1;

                                    win_rows += 1;
                                }
                                else if (league_tip["outcome"] == "F" ){
                                    loss_repeat += 1;
                                    max_loss_repeat += 1;
                                    recent_max_loss_repeat += 1;

                                    loss_rows += 1;
                                }
                            }
                            else {
                                if (league_tip["outcome"] == "V" ){
                                    if ( max_loss_repeat < loss_repeat )
                                        max_loss_repeat = loss_repeat;
                                    loss_repeat = 0;
                                    win_repeat += 1;

                                    if (recent_win_flag)
                                        recent_max_win_repeat += 1;
                                    if (recent_max_loss_repeat > 0)
                                        recent_loss_flag = false;

                                    if (league_tips[j-1]["outcome"] == "F" )
                                        win_rows += 1;
                                }
                                else if (league_tip["outcome"] == "F" ){
                                    if ( max_win_repeat < win_repeat )
                                        max_win_repeat = win_repeat;
                                    win_repeat = 0; 
                                    loss_repeat += 1;

                                    if (recent_loss_flag)
                                        recent_max_loss_repeat += 1; 
                                    if (recent_max_win_repeat > 0)
                                        recent_win_flag = false;

                                    if (league_tips[j-1]["outcome"] == "V" )
                                        loss_rows += 1;
                                }

                                if ( j == (league_tips.length - 1) ) {
                                    if ( max_loss_repeat < loss_repeat )
                                        max_loss_repeat = loss_repeat;
                                    if ( max_win_repeat < win_repeat )
                                        max_win_repeat = win_repeat;
                                }

                            }

                            if (league_tip["outcome"] == "V")
                                total_profits += league_tip["points_back"];
                            else
                                total_losses = total_losses - league_tip["points_back"];
                               
                        }

                        let win_rate = parseFloat((( win_bets / tips_len ) * 100).toFixed(2));
                        let avg_entry_odds = parseFloat((( total_entry / tips_len ) ).toFixed(2));
                        let avg_entry_back_odds = parseFloat((( entry_back_odd / tips_len ) ).toFixed(2));
                        let avg_entry_lay_odds = parseFloat((( entry_lay_odd / tips_len ) ).toFixed(2));

                        let avg_cashout_odds = "";
                        let avg_cashout_back_odds = "";
                        let avg_cashout_lay_odds = "";

                        if (cashout_len > 0) {
                            let avg_cashout_odds = parseFloat((( total_cashout / cashout_len ) ).toFixed(2));
                            let avg_cashout_back_odds = parseFloat((( cashout_back_odd / cashout_len ) ).toFixed(2));
                            let avg_cashout_lay_odds = parseFloat((( cashout_lay_odd / cashout_len ) ).toFixed(2));
                        }

                        let profit_factor = "";
                        if (total_losses > 0) {
                            profit_factor = parseFloat((( total_profits / total_losses ) ).toFixed(2));                            
                        }
                        else
                            profit_factor = parseFloat((total_profits + 1).toFixed(2));

                        let outcome_win = outcome_string.replace(/F+/g, "F");
                        let outcome_loss = outcome_string.replace(/V+/g, "V");
                        let continued_wins = outcome_win.split("F");
                        continued_wins = continued_wins.filter( item => item );
                        let continued_losses = outcome_loss.split("V");
                        continued_losses = continued_losses.filter( item => item );

                        let highest_win = this.get_highest_occurence(continued_wins);
                        continued_wins = continued_wins.filter( item => item != highest_win );
                        let second_highest_win = this.get_highest_occurence(continued_wins);

                        let highest_loss = this.get_highest_occurence(continued_losses);
                        continued_losses = continued_losses.filter( item => item != highest_loss );
                        let second_highest_loss = this.get_highest_occurence(continued_losses);

                        let league_data = {
                            'Country': league_tips[0]["Country"],
                            'League': league_tips[0]["League"],
                            'Sample': league_tips.length,
                            'Win Rate': win_rate,

                            'profit_factor': profit_factor,
                            
                            'avg Bet 365 Entry': avg_entry_odds,
                            'avg Bet 365 CO Odds': avg_cashout_odds,               
                            'avg_entry_back_odd':avg_entry_back_odds,
                            'avg_entry_lay_odd': avg_entry_lay_odds,
                            'avg_cashout_back_odd': avg_cashout_back_odds,
                            'avg_cashout_lay_odd': avg_cashout_lay_odds,
                            'recent_max_win_repeat': recent_max_win_repeat,
                            'max_win_repeat': max_win_repeat,
                            'recent_max_loss_repeat': recent_max_loss_repeat,
                            'max_loss_repeat': max_loss_repeat,
                            'win_avg': win_rows ? parseFloat((win_bets / win_rows).toFixed(2)) : "",
                            'loss_avg': loss_rows ? parseFloat((loss_bets / loss_rows).toFixed(2)) : "",
                            'win_trend1': highest_win ? highest_win.length : "",
                            'win_trend2': second_highest_win ? second_highest_win.length : "",
                            'loss_trend1': highest_loss ? highest_loss.length : "",
                            'loss_trend2': second_highest_loss ? second_highest_loss.length : "",
                            'last_bet': league_tips[0]["outcome"],
                        };
                        result.push(league_data);

                    }
                }
                return result;
            },
            filteredAllLeagueData() {
                let result = [];
                
                let league_tips = this.filteredData;
                if ( league_tips.length > 0 ) {
                    let tips_len = league_tips.length;

                    let cashout_len = 0;

                    let win_bets = 0;
                    let loss_bets = 0;
                    let win_rows = 0;
                    let loss_rows = 0;

                    let total_entry = 0;
                    let total_cashout = 0;
                    let entry_back_odd = 0;
                    let entry_lay_odd = 0;
                    let cashout_back_odd = 0;
                    let cashout_lay_odd = 0;

                    let win_repeat = 0;                    
                    let loss_repeat = 0;

                    let max_win_repeat = 0;
                    let max_loss_repeat = 0;

                    let recent_max_win_repeat = 0;
                    let recent_max_loss_repeat = 0;
                    let recent_win_flag = true;
                    let recent_loss_flag = true;

                    let total_profits = 0;
                    let total_losses = 0;

                    let outcome_string = "";

                    for ( var j=0; j<league_tips.length; j++) {
                        let league_tip = league_tips[j];
                        total_entry += league_tip["Bet 365 Entry"];
                        entry_back_odd += league_tip["entry_back_odd"];
                        entry_lay_odd += league_tip["entry_lay_odd"];

                        outcome_string += league_tip["outcome"];
                        if (league_tip["outcome"] == "V")
                            win_bets += 1;
                        else
                            loss_bets += 1;
                        if (league_tip["Bet 365 CO Odds"] != ""){
                            cashout_len += 1;
                            total_cashout += league_tip["Bet 365 CO Odds"];
                            cashout_back_odd += league_tip["cashout_back_odd"];
                            cashout_lay_odd += league_tip["cashout_lay_odd"];
                        }

                        if ( j == 0 ){
                            if (league_tip["outcome"] == "V" ){
                                win_repeat += 1;
                                max_win_repeat += 1;
                                recent_max_win_repeat += 1;

                                win_rows += 1;
                            }
                            else if (league_tip["outcome"] == "F" ){
                                loss_repeat += 1;
                                max_loss_repeat += 1;
                                recent_max_loss_repeat += 1;

                                loss_rows += 1;
                            }
                        }
                        else {
                            if (league_tip["outcome"] == "V" ){
                                if ( max_loss_repeat < loss_repeat )
                                    max_loss_repeat = loss_repeat;
                                loss_repeat = 0;
                                win_repeat += 1;

                                if (recent_win_flag)
                                    recent_max_win_repeat += 1;
                                if (recent_max_loss_repeat > 0)
                                    recent_loss_flag = false;

                                if (league_tips[j-1]["outcome"] == "F" )
                                    win_rows += 1;

                            }
                            else if (league_tip["outcome"] == "F" ){
                                if ( max_win_repeat < win_repeat )
                                    max_win_repeat = win_repeat;
                                win_repeat = 0; 
                                loss_repeat += 1;

                                if (recent_loss_flag)
                                    recent_max_loss_repeat += 1; 
                                if (recent_max_win_repeat > 0)
                                    recent_win_flag = false;

                                if (league_tips[j-1]["outcome"] == "V" )
                                    loss_rows += 1;
                            }

                            if ( j == (league_tips.length - 1) ) {
                                if ( max_loss_repeat < loss_repeat )
                                    max_loss_repeat = loss_repeat;
                                if ( max_win_repeat < win_repeat )
                                    max_win_repeat = win_repeat;
                            }

                        }

                        if (league_tip["outcome"] == "V")
                            total_profits += league_tip["points_back"];
                        else
                            total_losses = total_losses - league_tip["points_back"];
                    }

                    let win_rate = parseFloat((( win_bets / tips_len ) * 100).toFixed(2));
                    let avg_entry_odds = parseFloat((( total_entry / tips_len ) ).toFixed(2));
                    let avg_entry_back_odds = parseFloat((( entry_back_odd / tips_len ) ).toFixed(2));
                    let avg_entry_lay_odds = parseFloat((( entry_lay_odd / tips_len ) ).toFixed(2));

                    let avg_cashout_odds = "";
                    let avg_cashout_back_odds = "";
                    let avg_cashout_lay_odds = "";

                    if (cashout_len > 0) {
                        let avg_cashout_odds = parseFloat((( total_cashout / cashout_len ) ).toFixed(2));
                        let avg_cashout_back_odds = parseFloat((( cashout_back_odd / cashout_len ) ).toFixed(2));
                        let avg_cashout_lay_odds = parseFloat((( cashout_lay_odd / cashout_len ) ).toFixed(2));
                    }

                    let profit_factor = "";
                    if (total_losses > 0) {
                        profit_factor = parseFloat((( total_profits / total_losses ) ).toFixed(2));                            
                    }
                    else
                        profit_factor = parseFloat((total_profits + 1).toFixed(2));

                    let outcome_win = outcome_string.replace(/F+/g, "F");
                    let outcome_loss = outcome_string.replace(/V+/g, "V");
                    let continued_wins = outcome_win.split("F");
                    continued_wins = continued_wins.filter( item => item );
                    let continued_losses = outcome_loss.split("V");
                    continued_losses = continued_losses.filter( item => item );

                    let highest_win = this.get_highest_occurence(continued_wins);
                    continued_wins = continued_wins.filter( item => item != highest_win );
                    let second_highest_win = this.get_highest_occurence(continued_wins);

                    let highest_loss = this.get_highest_occurence(continued_losses);
                    continued_losses = continued_losses.filter( item => item != highest_loss );
                    let second_highest_loss = this.get_highest_occurence(continued_losses);

                    let league_data = {
                        'Country': this.$t("All"),
                        'League': this.$t("All"),
                        'Sample': league_tips.length,
                        'Win Rate': win_rate,

                        'profit_factor': profit_factor,
                        
                        'avg Bet 365 Entry': avg_entry_odds,
                        'avg Bet 365 CO Odds': avg_cashout_odds,               
                        'avg_entry_back_odd':avg_entry_back_odds,
                        'avg_entry_lay_odd': avg_entry_lay_odds,
                        'avg_cashout_back_odd': avg_cashout_back_odds,
                        'avg_cashout_lay_odd': avg_cashout_lay_odds,
                        'recent_max_win_repeat': recent_max_win_repeat,
                        'max_win_repeat': max_win_repeat,
                        'recent_max_loss_repeat': recent_max_loss_repeat,
                        'max_loss_repeat': max_loss_repeat,
                        'win_avg': win_rows ? parseFloat((win_bets / win_rows).toFixed(2)) : "",
                        'loss_avg': loss_rows ? parseFloat((loss_bets / loss_rows).toFixed(2)) : "",
                        'win_trend1': highest_win ? highest_win.length : "",
                        'win_trend2': second_highest_win ? second_highest_win.length : "",
                        'loss_trend1': highest_loss ? highest_loss.length : "",
                        'loss_trend2': second_highest_loss ? second_highest_loss.length : "",
                        'last_bet': league_tips[0]["outcome"],
                    };
                    result.push(league_data);

                }
                
                return result;
            }
        },
        methods: {
            ...mapActions([
                'getFeedsByStrategy',                
                'getFinancialByStrategyId',                
                
            ]),
            get_highest_occurence(array)
            {
                if(array.length == 0)
                    return null;
                var modeMap = {};
                var maxEl = array[0], maxCount = 1;
                for(var i = 0; i < array.length; i++)
                {
                    var el = array[i];
                    if(modeMap[el] == null)
                        modeMap[el] = 1;
                    else
                        modeMap[el]++;  
                    if(modeMap[el] > maxCount)
                    {
                        maxEl = el;
                        maxCount = modeMap[el];
                    }
                }
                return maxEl;
            },
            check_one_filter(model_option,min, max, home, away) {
                if (min !== "" && min.includes(",") === false)
                    min = parseInt(min);
                if (max !== "" && max.includes(",") === false)
                    max = parseInt(max);

                if (( min || max ) && (!home || !away))
                    return false;

                if (model_option === 'Home, Away' || model_option === 'Away, Home' ) {
                    if (model_option === 'Home, Away'){
                        if (min !== "" && min.includes(",")){
                            let home_min = parseInt(min.split(",")[0]);
                            let away_min = parseInt(min.split(",")[1]);
                            if (home < home_min || away < away_min)
                                return false;
                        }
                        if (max !== "" && max.includes(",")){
                            let home_max = parseInt(max.split(",")[0]);
                            let away_max = parseInt(max.split(",")[1]);
                            if (home > home_max || away > away_max)
                                return false;
                        }
                    }
                    else if (model_option === 'Away, Home'){
                        if (min !== "" && min.includes(",")){
                            let home_min = parseInt(min.split(",")[1]);
                            let away_min = parseInt(min.split(",")[0]);
                            if (home < home_min || away < away_min)
                                return false;
                        }
                        if (max !== "" && max.includes(",")){
                            let home_max = parseInt(max.split(",")[1]);
                            let away_max = parseInt(max.split(",")[0]);
                            if (home > home_max || away > away_max)
                                return false;
                        }
                    }
                    
                }

                else if (model_option === 'Home') {
                    if (min !== '' && home < min)
                        return false;
                    if (max !== '' && home > max)
                        return false;
                }
                else if (model_option === 'Away') {
                    if (min !== '' && away < min)
                        return false;
                    if (max !== '' && away > max)
                        return false;
                }
                else if (model_option === 'Home OR Away' || model_option === 'Away OR Home') {
                    if ((min !== '' && home < min) && (min !== '' && away < min))
                        return false;
                    if ((max !== '' && home > max) && (max !== '' && away > max))
                        return false;
                }
                else if (model_option === 'Home AND Away' || model_option === 'Away AND Home') {
                    if ((min !== '' && home < min) || (min !== '' && away < min))
                        return false;
                    if ((max !== '' && home > max) || (max !== '' && away > max))
                        return false;
                }
                else if (model_option === 'Home > Away' || model_option === 'Away < Home') {
                    let diff = home - away;
                    if (diff <= 0)
                        return false;                       
                    
                    if (min !== '' && diff <= min)
                        return false;
                    if (max !== '' && diff >= max)
                        return false;
                }
                else if (model_option === 'Home < Away'  || model_option === 'Away > Home') {
                    let diff = away - home;
                    if (diff <= 0)
                        return false;                       
                    
                    if (min !== '' && diff <= min)
                        return false;
                    if (max !== '' && diff >= max)
                        return false;
                }

                else if (model_option === 'sum greater than') {
                    let sum = home + away;
                    if (min !== '' && sum <= min)
                        return false;
                    if (max !== '' && sum >= max)
                        return false;

                }
                else if (model_option === 'sum minor than') {
                    let sum = home + away;
                    if (min !== '' && sum <= min)
                        return false;
                    if (max !== '' && sum >= max)
                        return false;

                }
                else if (model_option === 'diff greater than') {
                    let diff = Math.abs(away - home);
                    if (min !== '' && diff <= min)
                        return false;
                    if (max !== '' && diff >= max)
                        return false;

                }
                else if (model_option === 'diff minor than') {
                    let diff = Math.abs(away - home);
                    if (min !== '' && diff <= min)
                        return false;
                    if (max !== '' && diff >= max)
                        return false;

                }

                else if (model_option === 'Home = Away'  || model_option === 'Away = Home') {
                    return home === away;
                }

                else if (model_option === 'Home OR Away > Home OR Away' || model_option === 'Away OR Home > Away OR Home') {
                    let diff = Math.abs(away - home);
                    if (diff == 0)
                        return false;                       
                    
                    if (min !== '' && diff <= min)
                        return false;
                    if (max !== '' && diff >= max)
                        return false;
                }
                
                return true;
            },

            handleReset() {
                Swal.fire({
                        title: 'Are you sure?',
                        text: "You won't be able to revert this!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, reset it!'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // let user_id = localStorage.getItem('user_id');
                            // this.resetTip({user_id}).then(({status}) => {
                            //     if(status === 'success') {
                            //         this.data = this.data.filter(dItem => dItem.settled === 0 || dItem.type === 'label');
                            //         this.stat = {
                            //             ...this.stat,
                            //             total_tips: 0,
                            //             roi:  0,
                            //             profit_pts: 0,
                            //             w_rate: 0,
                            //             resetCount: this.stat.resetCount + 1
                            //         };
                            //     }
                            // });
                        }
                    })
            },
            check_bet_result(predictionType, scores) {
                let result = 0;

                let arr = predictionType.split(' - ');
                let compareScore = [0, 0]; //[home, away]

                let ft_score = [0, 0];
                let ht_score = [0, 0];
                if (scores.ft_score !== null)
                    ft_score = scores.ft_score.split('-');
                if (scores.ht_score !== null)
                    ht_score = scores.ht_score.split('-');

                compareScore = [parseInt(ft_score[0]), parseInt(ft_score[1])];
                if(arr[arr.length - 1] === 'FT') {
                    compareScore = [parseInt(ft_score[0]), parseInt(ft_score[1])];
                } else if(arr[arr.length - 1] === 'HT' && scores.ht_score) {
                    compareScore = [parseInt(ht_score[0]), parseInt(ht_score[1])];
                }
                let totalScore = compareScore[0] + compareScore[1];

                switch(arr[0]) {
                    case 'Home':
                    case '1':
                        result = compareScore[0] > compareScore[1] ? 1 : -1;                                                                
                        break;
                        
                    case 'Draw':
                    case 'X':
                        result = compareScore[0] === compareScore[1] ? 1 : -1;
                        break;
                            
                    case 'Away':
                    case '2':
                        result = compareScore[0] < compareScore[1] ? 1 : -1;
                        break;

                    case 'BTS':
                        result = compareScore[0] > 0 && compareScore[1] > 0 ? 1 : -1;
                        break;

                    case 'No BTS':
                        result = compareScore[0] * compareScore[1] === 0 ? 1 : -1;
                        break;

                    case 'Under':
                        result = totalScore < parseFloat(arr[1]) ? 1 : -1;
                        break;

                    case 'Over':
                        result = totalScore > parseFloat(arr[1]) ? 1 : -1;
                        break; 
                }
                if (predictionType == 'Home - Draw no bet') {
                    if (compareScore[0] > compareScore[1])
                        result = 1;
                    else if (compareScore[0] < compareScore[1])
                        result = -1;
                    else
                        result = 0;
                }
                else if (predictionType == 'Away - Draw no bet') {
                    if (compareScore[0] < compareScore[1])
                        result = 1;
                    else if (compareScore[0] > compareScore[1])
                        result = -1;
                    else
                        result = 0;
                }
                else if (predictionType == '1X - Double chance') {
                    if (compareScore[0] >= compareScore[1])
                        result = 1;
                    else
                        result = -1;
                }
                else if (predictionType == 'X2 - Double chance') {
                    if (compareScore[0] <= compareScore[1])
                        result = 1;
                    else
                        result = -1;
                }
                else if (predictionType == '12 - Double chance') {
                    if (compareScore[0] != compareScore[1]) 
                        result = 1;
                    else
                        result = -1;
                }

                return result;

            },
            init() {
                this.runTimer();
                const {id, notifications, userId} = this.$route.params;
                if(notifications) {
                    this.notifications = notifications.slice();
                }
                
                this.data = [];
                let dateOptions = [];
                let dateList = [];
                
                this.getFinancialByStrategyId({id: id, userId: userId}).then(({data: {feeds, stat, strategy, total_stat, stat1, userIsFollowed, strategyIsFollowed}}) => {

                    console.log("  feeds ========>>>>>>>>>>>>>>", feeds)
                    this.strategy = strategy;
                    this.userIsFollowed = userIsFollowed;
                    this.strategyIsFollowed = strategyIsFollowed;
                    this.stat = {
                        ...this.stat,
                        userId: parseInt(stat.user[0]._id),
                        userName: stat.user[0].alias,
                        userAvatar: stat.user[0].avatar,
                        followers: stat.followers,
                        resetCount: stat.resetCount
                    }
                    this.total_stat = {
                        ...this.total_stat,
                        userId: parseInt(stat.user[0]._id),
                        userName: total_stat.user[0].alias,
                        userAvatar: total_stat.user[0].avatar,
                        followers: total_stat.followers,
                        resetCount: total_stat.resetCount
                    }
                    if(stat.totalCount) {
                        this.stat = {
                            ...this.stat,
                            total_tips: stat.totalCount,
                            roi:  stat.stakeTotal ? (stat.profitPTS / stat.stakeTotal * 100).toFixed(2) : 0,
                            profit_pts: stat.profitPTS.toFixed(2),
                            w_rate: stat.settledLose + stat.settledWin ? ((stat.settledWin / (stat.settledLose + stat.settledWin)) * 100).toFixed(2) : 0,
                            avg_odd: stat.settledLose + stat.settledWin ? ((stat.totalOdd / (stat.settledLose + stat.settledWin))).toFixed(2) : 0,
                        };
                    }
                    if(total_stat.totalCount) {
                        this.total_stat = {
                            ...this.total_stat,
                            total_tips: total_stat.totalCount,
                            roi:  total_stat.stakeTotal ? (total_stat.profitPTS / total_stat.stakeTotal * 100).toFixed(2) : 0,
                            profit_pts: total_stat.profitPTS.toFixed(2),
                            w_rate: total_stat.settledLose + total_stat.settledWin ? ((total_stat.settledWin / (total_stat.settledLose + total_stat.settledWin)) * 100).toFixed(2) : 0,
                            avg_odd: total_stat.settledLose + total_stat.settledWin ? ((total_stat.totalOdd / (total_stat.settledLose + total_stat.settledWin))).toFixed(2) : 0,
                        };
                    }
                    if(stat1.totalCount) {
                        this.real_stat = {
                            ...this.real_stat,
                            total_tips: stat1.totalCount,
                            roi:  stat1.stakeTotal ? (stat1.profitPTS / stat1.stakeTotal * 100).toFixed(2) : 0,
                            profit_pts: stat1.profitPTS.toFixed(2),
                            w_rate: stat1.settledLose + stat1.settledWin ? ((stat1.settledWin / (stat1.settledLose + stat1.settledWin)) * 100).toFixed(2) : 0,
                            avg_odd: stat1.settledLose + stat1.settledWin ? ((stat1.totalOdd / (stat1.settledLose + stat1.settledWin))).toFixed(2) : 0,
                        };
                    }

                    // new part for single bets

                    let total_bets = [];
                    let leverage_stake = this.leverage_stake ? parseFloat(this.leverage_stake) : 0;
                    let bf = 0;
                    let start_bankroll = 0;
                    let compounding_size = 0;

                    if (this.bf)
                        bf = parseFloat(this.bf);
                    if (this.start_bankroll)
                        start_bankroll = parseFloat(this.start_bankroll);
                    if (this.compounding_size)
                        compounding_size = parseFloat(this.compounding_size);

                    let max_comp_back_cur_bank = start_bankroll;
                    let max_comp_pay_cur_bank = start_bankroll;
                    let max_comp_lia_cur_bank = start_bankroll;

                    let tip_count = 0;

                    let countryLeague_list = [];
                    let countryLeague_dic = [];

                    for ( var i=0; i<feeds.length; i++) {
                        let tip = feeds[i];
                        let one_bet = {};
                        one_bet["index"] = tip_count;

                        const {scores} = tip["fixture"][0];                        
                        one_bet['result'] = `${scores.ft_score} FT(${scores.ht_score} HT)`;
                        
                        one_bet["Country"] = tip["country"];
                        one_bet["League"] = tip["league"];
                        one_bet["country_league"] = tip["country"] + " - " + tip["league"];

                        if ( !countryLeague_list.includes(one_bet["country_league"])) {
                            countryLeague_list.push(one_bet["country_league"]);
                            countryLeague_dic.push({
                                country_league: one_bet["country_league"]
                            })
                        }

                        if ( tip["dateTime"] )
                            one_bet["Post Date"] = tip["dateTime"];
                        else
                            one_bet["Post Date"] = tip["postedDateTime"];

                        let dateTime = convertUTCToLocal(one_bet["Post Date"], (new Date()).getTimezoneOffset() / 60);
                        
                        one_bet["value_date"] = valueDate( dateTime );

                        if ( !dateList.includes(one_bet["value_date"]) ){
                            dateOptions.push({
                                value: one_bet["value_date"],
                                label: labelDate( dateTime )
                            });
                            dateList.push(one_bet["value_date"]);
                        }

                        let localTeamName = tip["fixture"][0].localTeamName;
                        let visitorTeamName = tip["fixture"][0].visitorTeamName;
                        if ( tip["fixture"][0].home_rank )
                            localTeamName += " (" + tip["fixture"][0].home_rank + ")";
                        if ( tip["fixture"][0].away_rank )
                            visitorTeamName += " (" + tip["fixture"][0].away_rank + ")";

                        one_bet["home_rank"] = tip["fixture"][0].home_rank;
                        one_bet["away_rank"] = tip["fixture"][0].away_rank;

                        one_bet["Event"] = localTeamName + " V " + visitorTeamName;
                        one_bet["Prediction"] = tip["predictionType"];
                        one_bet["Prediction"] = one_bet["Prediction"].replace("Double chance", "DC")
                        
                        one_bet["Bet Side"] = this.$t("Back");
                        one_bet["tipORcover"] = this.$t("tip");

                        one_bet["Entry min"] = tip["status"];
                        if ( tip["cashout"] )
                            one_bet["Cash out"] = "Yes";
                        else
                            one_bet["Cash out"] = "No";
                        one_bet["Bet 365 Entry"] = tip["odd"];
                        one_bet["Bet 365 CO Odds"] = tip["cashoutOdd"] ? tip["cashoutOdd"] : "";
                        one_bet["stake"] = tip["stake"];
                        one_bet["entry_back_odd"] = tip["odd"];
                        one_bet["entry_lay_odd"] = tip["odd"];
                        one_bet["cashout_back_odd"] = tip["cashoutOdd"] ? tip["cashoutOdd"] : "";
                        one_bet["cashout_lay_odd"] = tip["cashoutOdd"] ? tip["cashoutOdd"] : "";

                        let profit_result = this.check_bet_result( tip["predictionType"], scores)
                        one_bet["real Outcome"] = profit_result >= 0 ? "V" : "F";
                        // one_bet["real Outcome"] = tip["profitPts"] >= 0 ? "V" : "F";


                        if ( one_bet["Cash out"] == "Yes" ){
                            if (one_bet["Bet 365 Entry"] > one_bet["Bet 365 CO Odds"])
                                one_bet["outcome"] = "V";
                            else
                                one_bet["outcome"] = "F";
                        }
                        else
                            one_bet["outcome"] = one_bet["real Outcome"];

                        one_bet["Lay Risk"] = parseFloat((one_bet["stake"] * one_bet["entry_lay_odd"] - one_bet["stake"]).toFixed(2));

                        // P/L compounding => Stake Back, stake lay, liab stake
                        if ( tip_count == 0) {
                            one_bet["comp_back_stake_back"] = parseFloat(( start_bankroll  *  compounding_size/100 ).toFixed(2));

                            one_bet["comp_pay_stake_lay"] = parseFloat(( start_bankroll  *  compounding_size/100 ).toFixed(2));

                            one_bet["comp_lia_stake_lay"] = parseFloat(( (start_bankroll * compounding_size/100 ) / ( 1 / ( 100 / one_bet["entry_lay_odd"] / 100 ) - 1) ).toFixed(2));

                        }
                        else {
                            if ( total_bets[tip_count-1]["outcome"] == "V" || total_bets[tip_count-1]["outcome"] == 0 ) {
                                one_bet["comp_back_stake_back"] = parseFloat(( total_bets[tip_count-1]["comp_back_cur_bank"] * ( 1 + compounding_size/100 ) - total_bets[tip_count-1]["comp_back_cur_bank"]).toFixed(2));
                                
                            }
                            else {
                                one_bet["comp_back_stake_back"] = parseFloat(( total_bets[tip_count-1]["comp_back_cur_bank"] * compounding_size/100 ).toFixed(2));                               
                            }
                            one_bet["comp_pay_stake_lay"] =  parseFloat(( total_bets[tip_count-1]["comp_pay_cur_bank"] * compounding_size/100 ).toFixed(2));
                            one_bet["comp_lia_stake_lay"] = parseFloat(( (total_bets[tip_count-1]["comp_pay_cur_bank"] * compounding_size/100 ) / ( 1 / ( 100 / one_bet["entry_lay_odd"] / 100 ) - 1) ).toFixed(2));
                        }
                        
                        // points_back
                        one_bet["points_liab_stake"] = parseFloat((one_bet["stake"] / ( 1 / ( 100 / one_bet["entry_lay_odd"] / 100 ) - 1 )).toFixed(2));
                        one_bet["points_liab_risk"] = parseFloat((one_bet["points_liab_stake"] * one_bet["entry_lay_odd"] - one_bet["points_liab_stake"]).toFixed(2));

                        // Compounding => lay Payout => lay risk
                        one_bet["comp_pay_risk"] = parseFloat(( one_bet["comp_pay_stake_lay"] * one_bet["entry_lay_odd"] - one_bet["comp_pay_stake_lay"] ).toFixed(2));

                        if ( one_bet["Cash out"] == "Yes" ) {
                            if ( one_bet["outcome"] == "F" ) {
                                one_bet["points_back"] = parseFloat(((one_bet["stake"] * one_bet["entry_back_odd"] / one_bet["cashout_lay_odd"] - one_bet["stake"]) * ( 1 - bf / 100 )).toFixed(2));
                                one_bet["points_payout"] = parseFloat((( one_bet["stake"] - one_bet["stake"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"]) * ( 1 - bf / 100 )).toFixed(2));
                                one_bet["points_liability"] = parseFloat(((one_bet["points_liab_stake"] - one_bet["points_liab_stake"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"]) * ( 1 - bf / 100 )).toFixed(2));

                                // P/L compounding => Back
                                one_bet["comp_back"] = parseFloat((one_bet["comp_back_stake_back"] * one_bet["entry_back_odd"] / one_bet["cashout_lay_odd"] - one_bet["comp_back_stake_back"]).toFixed(2));

                                // P/L compounding => Lay => Payout
                                one_bet["comp_payout"] = parseFloat((( one_bet["comp_pay_stake_lay"] - one_bet["comp_pay_stake_lay"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"] ) * ( 1 - bf / 100 )).toFixed(2));

                                // P/L compounding => Lay => Liability
                                one_bet["comp_liability"] = parseFloat((( one_bet["comp_lia_stake_lay"] - one_bet["comp_lia_stake_lay"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"] ) * ( 1 - bf / 100 )).toFixed(2));

                                // P/L Leverage stake
                                one_bet["stake_back"] = parseFloat((one_bet["stake"] * leverage_stake * one_bet["entry_back_odd"] / one_bet["cashout_lay_odd"] - one_bet["stake"] * leverage_stake).toFixed(2));
                                one_bet["stake_payout"] = parseFloat((one_bet["stake"] * leverage_stake - ((one_bet["stake"] * leverage_stake) * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"]) * ( 1 - bf / 100 ) ).toFixed(2));
                                one_bet["stake_liability"] = parseFloat((one_bet["points_liab_stake"] * leverage_stake - ((one_bet["points_liab_stake"] * leverage_stake) * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"]) * ( 1 - bf / 100 ) ).toFixed(2));

                            }
                            else {
                                one_bet["points_back"] = parseFloat((one_bet["stake"] * one_bet["entry_back_odd"] / one_bet["cashout_lay_odd"] - one_bet["stake"]).toFixed(2));
                                one_bet["points_payout"] = parseFloat(( one_bet["stake"] - one_bet["stake"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"] ).toFixed(2));
                                one_bet["points_liability"] = parseFloat((one_bet["points_liab_stake"] - one_bet["points_liab_stake"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"]).toFixed(2));

                                // P/L compounding => Back
                                one_bet["comp_back"] = parseFloat(((one_bet["comp_back_stake_back"] * one_bet["entry_back_odd"] / one_bet["cashout_lay_odd"] - one_bet["comp_back_stake_back"]) * ( 1 - bf / 100 )).toFixed(2));

                                // P/L compounding => Lay => Payout
                                one_bet["comp_payout"] = parseFloat((one_bet["comp_pay_stake_lay"] - one_bet["comp_pay_stake_lay"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"] ).toFixed(2));

                                // P/L compounding => Lay => Liability
                                one_bet["comp_liability"] = parseFloat(( one_bet["comp_lia_stake_lay"] - one_bet["comp_lia_stake_lay"] * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"] ).toFixed(2));

                                // P/L Leverage stake
                                one_bet["stake_back"] = parseFloat((one_bet["stake"] * leverage_stake * one_bet["entry_back_odd"] / one_bet["cashout_lay_odd"] - one_bet["stake"] * leverage_stake).toFixed(2));
                                one_bet["stake_payout"] = parseFloat((one_bet["stake"] * leverage_stake - ((one_bet["stake"] * leverage_stake) * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"]) ).toFixed(2));
                                one_bet["stake_liability"] = parseFloat((one_bet["points_liab_stake"] * leverage_stake - ((one_bet["points_liab_stake"] * leverage_stake) * one_bet["entry_lay_odd"] / one_bet["cashout_back_odd"]) ).toFixed(2));
                            }
                        }
                        else {
                            if ( one_bet["outcome"] == "V" ) {

                                one_bet["points_back"] = parseFloat(((one_bet["stake"] * one_bet["entry_back_odd"] - one_bet["stake"]) * ( 1 - bf / 100 )).toFixed(2));

                                one_bet["points_payout"] = parseFloat(( one_bet["stake"] - one_bet["stake"] * one_bet["entry_lay_odd"]).toFixed(2));
                                one_bet["points_liability"] = parseFloat((one_bet["points_liab_stake"] - one_bet["points_liab_stake"] * one_bet["entry_lay_odd"] ).toFixed(2));

                                // P/L compounding => Back
                                one_bet["comp_back"] = parseFloat(((one_bet["comp_back_stake_back"] * one_bet["entry_back_odd"] - one_bet["comp_back_stake_back"]) * ( 1 - bf / 100 )).toFixed(2));

                                // P/L compounding => Lay => Payout
                                one_bet["comp_payout"] = parseFloat((one_bet["comp_pay_stake_lay"] - one_bet["comp_pay_stake_lay"] * one_bet["entry_lay_odd"] ).toFixed(2));

                                // P/L compounding => Lay => Liability
                                one_bet["comp_liability"] = parseFloat((one_bet["comp_lia_stake_lay"] - one_bet["comp_lia_stake_lay"] * one_bet["entry_lay_odd"] ).toFixed(2));

                                // P/L Leverage stake
                                one_bet["stake_back"] = parseFloat((one_bet["stake"] * leverage_stake * one_bet["entry_back_odd"]  - one_bet["stake"] * leverage_stake).toFixed(2));
                                one_bet["stake_payout"] = parseFloat((one_bet["stake"] * leverage_stake - (one_bet["stake"] * leverage_stake * one_bet["entry_lay_odd"] ) ).toFixed(2));
                                one_bet["stake_liability"] = parseFloat((one_bet["points_liab_stake"] * leverage_stake - one_bet["points_liab_stake"] * leverage_stake * one_bet["entry_lay_odd"] ).toFixed(2));
                            }
                            else {
                                one_bet["points_back"] = parseFloat((one_bet["stake"] * -1).toFixed(2));
                                one_bet["points_payout"] = parseFloat((one_bet["stake"] * ( 1 - bf / 100 )).toFixed(2));
                                one_bet["points_liability"] = parseFloat((one_bet["points_liab_stake"] * ( 1 - bf / 100 )).toFixed(2));

                                // P/L compounding => Back
                                one_bet["comp_back"] = parseFloat((one_bet["comp_back_stake_back"] * -1).toFixed(2));

                                // P/L compounding => Lay => Payout
                                one_bet["comp_payout"] = parseFloat(( one_bet["comp_pay_stake_lay"]  * ( 1 - bf / 100 )).toFixed(2));

                                // P/L compounding => Lay => Liability
                                one_bet["comp_liability"] = parseFloat(( one_bet["comp_lia_stake_lay"]  * ( 1 - bf / 100 )).toFixed(2));

                                // P/L Leverage stake
                                one_bet["stake_back"] = parseFloat(( -1 * one_bet["stake"] * leverage_stake).toFixed(2));
                                one_bet["stake_payout"] = parseFloat((one_bet["stake"] * leverage_stake * ( 1 - bf / 100 ) ).toFixed(2));
                                one_bet["stake_liability"] = parseFloat((one_bet["points_liab_stake"] * leverage_stake * ( 1 - bf / 100 ) ).toFixed(2));
                            }
                        }

                        // P/L compounding => Back => current Bank
                        // P/L compounding => Lay(payout) => current Bank
                        if ( tip_count == 0) {
                            one_bet["comp_back_cur_bank"] = parseFloat(( one_bet["comp_back"] + start_bankroll ).toFixed(2));
                            if ( one_bet["comp_back_cur_bank"] < max_comp_back_cur_bank )
                                one_bet["comp_back_draw_down"] = parseFloat(( one_bet["comp_back"] / max_comp_back_cur_bank * 100 ).toFixed(2));
                            else
                                one_bet["comp_back_draw_down"] = 0;

                            one_bet["comp_pay_cur_bank"] = parseFloat(( one_bet["comp_payout"] + start_bankroll ).toFixed(2));
                            if ( one_bet["comp_pay_cur_bank"] < max_comp_pay_cur_bank )
                                one_bet["comp_pay_draw_down"] = parseFloat(( one_bet["comp_payout"] / max_comp_pay_cur_bank * 100 ).toFixed(2));
                            else
                                one_bet["comp_pay_draw_down"] = 0;

                            one_bet["comp_lia_cur_bank"] = parseFloat(( one_bet["comp_liability"] + start_bankroll ).toFixed(2));
                            if ( one_bet["comp_lia_cur_bank"] < max_comp_lia_cur_bank )
                                one_bet["comp_lia_draw_down"] = parseFloat(( one_bet["comp_liability"] / max_comp_lia_cur_bank * 100 ).toFixed(2));
                            else
                                one_bet["comp_lia_draw_down"] = 0;

                        }
                        else {
                            one_bet["comp_back_cur_bank"] = parseFloat(( one_bet["comp_back"] + total_bets[tip_count-1]["comp_back_cur_bank"] ).toFixed(2));
                            max_comp_back_cur_bank = Math.max(max_comp_back_cur_bank, total_bets[tip_count-1]["comp_back_cur_bank"]);
                            if ( one_bet["comp_back_cur_bank"] < max_comp_back_cur_bank )
                                one_bet["comp_back_draw_down"] = parseFloat(( one_bet["comp_back"] / max_comp_back_cur_bank * 100 + total_bets[tip_count-1]["comp_back_draw_down"] ).toFixed(2));
                            else
                                one_bet["comp_back_draw_down"] = 0;

                            one_bet["comp_pay_cur_bank"] = parseFloat(( one_bet["comp_payout"] + total_bets[tip_count-1]["comp_pay_cur_bank"] ).toFixed(2));
                            max_comp_pay_cur_bank = Math.max(max_comp_pay_cur_bank, total_bets[tip_count-1]["comp_pay_cur_bank"]);
                            if ( one_bet["comp_pay_cur_bank"] < max_comp_pay_cur_bank )
                                one_bet["comp_pay_draw_down"] = parseFloat(( one_bet["comp_payout"] / max_comp_pay_cur_bank * 100 + total_bets[tip_count-1]["comp_pay_draw_down"] ).toFixed(2));
                            else
                                one_bet["comp_pay_draw_down"] = 0;

                            one_bet["comp_lia_cur_bank"] = parseFloat(( one_bet["comp_liability"] + total_bets[tip_count-1]["comp_lia_cur_bank"] ).toFixed(2));
                            max_comp_lia_cur_bank = Math.max(max_comp_lia_cur_bank, total_bets[tip_count-1]["comp_lia_cur_bank"]);
                            if ( one_bet["comp_lia_cur_bank"] < max_comp_lia_cur_bank )
                                one_bet["comp_lia_draw_down"] = parseFloat(( one_bet["comp_liability"] / max_comp_lia_cur_bank * 100 + total_bets[tip_count-1]["comp_lia_draw_down"] ).toFixed(2));
                            else
                                one_bet["comp_lia_draw_down"] = 0;
                        }

                        total_bets.push(one_bet);                        

                        tip_count += 1;

                        if ( tip.cover_odd && tip.cover_predictionType && tip.cover_stake ) {
                            let cover_bet = {...one_bet};

                            cover_bet["index"] = tip_count;
                            cover_bet["Prediction"] = tip["cover_predictionType"];                            
                            cover_bet["tipORcover"] = this.$t("cover");

                            
                            if ( tip["cover_cashout"] )
                                cover_bet["Cash out"] = "Yes";
                            else
                                cover_bet["Cash out"] = "No";
                            cover_bet["Bet 365 Entry"] = tip["cover_odd"];
                            cover_bet["Bet 365 CO Odds"] = tip["cover_cashoutOdd"] ? tip["cover_cashoutOdd"] : "";
                            cover_bet["stake"] = tip["cover_stake"];
                            cover_bet["entry_back_odd"] = tip["cover_odd"];
                            cover_bet["entry_lay_odd"] = tip["cover_odd"];
                            cover_bet["cashout_back_odd"] = tip["cover_cashoutOdd"] ? tip["cover_cashoutOdd"] : "";
                            cover_bet["cashout_lay_odd"] = tip["cover_cashoutOdd"] ? tip["cover_cashoutOdd"] : "";

                            let cover_profit_result = this.check_bet_result( tip["cover_predictionType"], scores)
                            cover_bet["real Outcome"] = cover_profit_result > 0 ? "V" : "F";
                            // cover_bet["real Outcome"] = tip["cover_profitPts"] > 0 ? "V" : "F";

                            if ( cover_bet["Cash out"] == "Yes" ){
                                if (cover_bet["Bet 365 Entry"] > cover_bet["Bet 365 CO Odds"])
                                    cover_bet["outcome"] = "V";
                                else
                                    cover_bet["outcome"] = "F";
                            }
                            else
                                cover_bet["outcome"] = cover_bet["real Outcome"];

                            cover_bet["Lay Risk"] = parseFloat((cover_bet["stake"] * cover_bet["entry_lay_odd"] - cover_bet["stake"]).toFixed(2));

                            // P/L compounding => Stake Back, stake lay, liab stake
                            if ( tip_count == 0) {
                                cover_bet["comp_back_stake_back"] = parseFloat(( start_bankroll  *  compounding_size/100 ).toFixed(2));

                                cover_bet["comp_pay_stake_lay"] = parseFloat(( start_bankroll  *  compounding_size/100 ).toFixed(2));

                                cover_bet["comp_lia_stake_lay"] = parseFloat(( (start_bankroll * compounding_size/100 ) / ( 1 / ( 100 / cover_bet["entry_lay_odd"] / 100 ) - 1) ).toFixed(2));

                            }
                            else {
                                if ( total_bets[tip_count-1]["outcome"] == "V" || total_bets[tip_count-1]["outcome"] == 0 ) {
                                    cover_bet["comp_back_stake_back"] = parseFloat(( total_bets[tip_count-1]["comp_back_cur_bank"] * ( 1 + compounding_size/100 ) - total_bets[tip_count-1]["comp_back_cur_bank"]).toFixed(2));
                                    
                                }
                                else {
                                    cover_bet["comp_back_stake_back"] = parseFloat(( total_bets[tip_count-1]["comp_back_cur_bank"] * compounding_size/100 ).toFixed(2));                               
                                }
                                cover_bet["comp_pay_stake_lay"] =  parseFloat(( total_bets[tip_count-1]["comp_pay_cur_bank"] * compounding_size/100 ).toFixed(2));
                                cover_bet["comp_lia_stake_lay"] = parseFloat(( (total_bets[tip_count-1]["comp_pay_cur_bank"] * compounding_size/100 ) / ( 1 / ( 100 / cover_bet["entry_lay_odd"] / 100 ) - 1) ).toFixed(2));
                            }
                            
                            
                            // points_back
                            cover_bet["points_liab_stake"] = parseFloat((cover_bet["stake"] / ( 1 / ( 100 / cover_bet["entry_lay_odd"] / 100 ) - 1 )).toFixed(2));
                            cover_bet["points_liab_risk"] = parseFloat((cover_bet["points_liab_stake"] * cover_bet["entry_lay_odd"] - cover_bet["points_liab_stake"]).toFixed(2));

                            // Compounding => lay Payout => lay risk
                            cover_bet["comp_pay_risk"] = parseFloat(( cover_bet["comp_pay_stake_lay"] * cover_bet["entry_lay_odd"] - cover_bet["comp_pay_stake_lay"] ).toFixed(2));

                            if ( cover_bet["Cash out"] == "Yes" ) {
                                if ( cover_bet["outcome"] == "F" ) {

                                    cover_bet["points_back"] = parseFloat(((cover_bet["stake"] * cover_bet["entry_back_odd"] / cover_bet["cashout_lay_odd"] - cover_bet["stake"]) * ( 1 - bf / 100 )).toFixed(2));
                                    cover_bet["points_payout"] = parseFloat((( cover_bet["stake"] - cover_bet["stake"] * cover_bet["entry_lay_odd"] / cover_bet["cashout_back_odd"]) * ( 1 - bf / 100 )).toFixed(2));
                                    cover_bet["points_liability"] = parseFloat(((cover_bet["points_liab_stake"] - cover_bet["points_liab_stake"] * cover_bet["entry_lay_odd"] / cover_bet["cashout_back_odd"]) * ( 1 - bf / 100 )).toFixed(2));

                                    // P/L compounding => Back
                                    cover_bet["comp_back"] = parseFloat((cover_bet["comp_back_stake_back"] * cover_bet["entry_back_odd"] / cover_bet["cashout_lay_odd"] - cover_bet["comp_back_stake_back"]).toFixed(2));

                                    // P/L compounding => Lay => Payout
                                    cover_bet["comp_payout"] = parseFloat((( cover_bet["comp_pay_stake_lay"] - cover_bet["comp_pay_stake_lay"] * cover_bet["entry_lay_odd"] / cover_bet["cashout_back_odd"] ) * ( 1 - bf / 100 )).toFixed(2));

                                    // P/L compounding => Lay => Liability
                                    cover_bet["comp_liability"] = parseFloat((( cover_bet["comp_lia_stake_lay"] - cover_bet["comp_lia_stake_lay"] * cover_bet["entry_lay_odd"] / cover_bet["cashout_back_odd"] ) * ( 1 - bf / 100 )).toFixed(2));

                                    // P/L Leverage stake
                                    cover_bet["stake_back"] = parseFloat((cover_bet["stake"] * leverage_stake * cover_bet["entry_back_odd"] / cover_bet["cashout_lay_odd"] - cover_bet["stake"] * leverage_stake).toFixed(2));
                                    cover_bet["stake_payout"] = parseFloat((cover_bet["stake"] * leverage_stake - ((cover_bet["stake"] * leverage_stake) * cover_bet["entry_lay_odd"] / cover_bet["cashout_back_odd"]) * ( 1 - bf / 100 ) ).toFixed(2));
                                    cover_bet["stake_liability"] = parseFloat((cover_bet["points_liab_stake"] * leverage_stake - ((cover_bet["points_liab_stake"] * leverage_stake) * cover_bet["entry_lay_odd"] / cover_bet["cashout_back_odd"]) * ( 1 - bf / 100 ) ).toFixed(2));

                                }
                                else {
                                    cover_bet["points_back"] = parseFloat((cover_bet["stake"] * cover_bet["entry_back_odd"] / cover_bet["cashout_lay_odd"] - cover_bet["stake"]).toFixed(2));
                                    cover_bet["points_payout"] = parseFloat(( cover_bet["stake"] - cover_bet["stake"] * cover_bet["entry_lay_odd"] / cover_bet["cashout_back_odd"] ).toFixed(2));
                                    cover_bet["points_liability"] = parseFloat((cover_bet["points_liab_stake"] - cover_bet["points_liab_stake"] * cover_bet["entry_lay_odd"] / cover_bet["cashout_back_odd"]).toFixed(2));

                                    // P/L compounding => Back
                                    cover_bet["comp_back"] = parseFloat(((cover_bet["comp_back_stake_back"] * cover_bet["entry_back_odd"] / cover_bet["cashout_lay_odd"] - cover_bet["comp_back_stake_back"]) * ( 1 - bf / 100 )).toFixed(2));

                                    // P/L compounding => Lay => Payout
                                    cover_bet["comp_payout"] = parseFloat((cover_bet["comp_pay_stake_lay"] - cover_bet["comp_pay_stake_lay"] * cover_bet["entry_lay_odd"] / cover_bet["cashout_back_odd"] ).toFixed(2));

                                    // P/L compounding => Lay => Liability
                                    cover_bet["comp_liability"] = parseFloat(( cover_bet["comp_lia_stake_lay"] - cover_bet["comp_lia_stake_lay"] * cover_bet["entry_lay_odd"] / cover_bet["cashout_back_odd"] ).toFixed(2));

                                    // P/L Leverage stake
                                    cover_bet["stake_back"] = parseFloat((cover_bet["stake"] * leverage_stake * cover_bet["entry_back_odd"] / cover_bet["cashout_lay_odd"] - cover_bet["stake"] * leverage_stake).toFixed(2));
                                    cover_bet["stake_payout"] = parseFloat((cover_bet["stake"] * leverage_stake - ((cover_bet["stake"] * leverage_stake) * cover_bet["entry_lay_odd"] / cover_bet["cashout_back_odd"]) ).toFixed(2));
                                    cover_bet["stake_liability"] = parseFloat((cover_bet["points_liab_stake"] * leverage_stake - ((cover_bet["points_liab_stake"] * leverage_stake) * cover_bet["entry_lay_odd"] / cover_bet["cashout_back_odd"]) ).toFixed(2));
                                }
                            }
                            else {
                                if ( cover_bet["outcome"] == "V" ) {

                                    cover_bet["points_back"] = parseFloat(((cover_bet["stake"] * cover_bet["entry_back_odd"] - cover_bet["stake"]) * ( 1 - bf / 100 )).toFixed(2));

                                    cover_bet["points_payout"] = parseFloat(( cover_bet["stake"] - cover_bet["stake"] * cover_bet["entry_lay_odd"]).toFixed(2));
                                    cover_bet["points_liability"] = parseFloat((cover_bet["points_liab_stake"] - cover_bet["points_liab_stake"] * cover_bet["entry_lay_odd"] ).toFixed(2));

                                    // P/L compounding => Back
                                    cover_bet["comp_back"] = parseFloat(((cover_bet["comp_back_stake_back"] * cover_bet["entry_back_odd"] - cover_bet["comp_back_stake_back"]) * ( 1 - bf / 100 )).toFixed(2));

                                    // P/L compounding => Lay => Payout
                                    cover_bet["comp_payout"] = parseFloat((cover_bet["comp_pay_stake_lay"] - cover_bet["comp_pay_stake_lay"] * cover_bet["entry_lay_odd"] ).toFixed(2));

                                    // P/L compounding => Lay => Liability
                                    cover_bet["comp_liability"] = parseFloat((cover_bet["comp_lia_stake_lay"] - cover_bet["comp_lia_stake_lay"] * cover_bet["entry_lay_odd"] ).toFixed(2));

                                    // P/L Leverage stake
                                    cover_bet["stake_back"] = parseFloat((cover_bet["stake"] * leverage_stake * cover_bet["entry_back_odd"]  - cover_bet["stake"] * leverage_stake).toFixed(2));
                                    cover_bet["stake_payout"] = parseFloat((cover_bet["stake"] * leverage_stake - (cover_bet["stake"] * leverage_stake * cover_bet["entry_lay_odd"] ) ).toFixed(2));
                                    cover_bet["stake_liability"] = parseFloat((cover_bet["points_liab_stake"] * leverage_stake - cover_bet["points_liab_stake"] * leverage_stake * cover_bet["entry_lay_odd"] ).toFixed(2));
                                }
                                else {
                                    cover_bet["points_back"] = parseFloat((cover_bet["stake"] * -1).toFixed(2));
                                    cover_bet["points_payout"] = parseFloat((cover_bet["stake"] * ( 1 - bf / 100 )).toFixed(2));
                                    cover_bet["points_liability"] = parseFloat((cover_bet["points_liab_stake"] * ( 1 - bf / 100 )).toFixed(2));

                                    // P/L compounding => Back
                                    cover_bet["comp_back"] = parseFloat((cover_bet["comp_back_stake_back"] * -1).toFixed(2));

                                    // P/L compounding => Lay => Payout
                                    cover_bet["comp_payout"] = parseFloat(( cover_bet["comp_pay_stake_lay"]  * ( 1 - bf / 100 )).toFixed(2));

                                    // P/L compounding => Lay => Liability
                                    cover_bet["comp_liability"] = parseFloat(( cover_bet["comp_lia_stake_lay"]  * ( 1 - bf / 100 )).toFixed(2));

                                    // P/L Leverage stake
                                    cover_bet["stake_back"] = parseFloat(( -1 * cover_bet["stake"] * leverage_stake).toFixed(2));
                                    cover_bet["stake_payout"] = parseFloat((cover_bet["stake"] * leverage_stake * ( 1 - bf / 100 ) ).toFixed(2));
                                    cover_bet["stake_liability"] = parseFloat((cover_bet["points_liab_stake"] * leverage_stake * ( 1 - bf / 100 ) ).toFixed(2));
                                }
                            }

                            // P/L compounding => Back => current Bank
                            // P/L compounding => Lay(payout) => current Bank
                            if ( tip_count == 0) {
                                cover_bet["comp_back_cur_bank"] = parseFloat(( cover_bet["comp_back"] + start_bankroll ).toFixed(2));
                                if ( cover_bet["comp_back_cur_bank"] < max_comp_back_cur_bank )
                                    cover_bet["comp_back_draw_down"] = parseFloat(( cover_bet["comp_back"] / max_comp_back_cur_bank * 100 ).toFixed(2));
                                else
                                    cover_bet["comp_back_draw_down"] = 0;

                                cover_bet["comp_pay_cur_bank"] = parseFloat(( cover_bet["comp_payout"] + start_bankroll ).toFixed(2));
                                if ( cover_bet["comp_pay_cur_bank"] < max_comp_pay_cur_bank )
                                    cover_bet["comp_pay_draw_down"] = parseFloat(( cover_bet["comp_payout"] / max_comp_pay_cur_bank * 100 ).toFixed(2));
                                else
                                    cover_bet["comp_pay_draw_down"] = 0;

                                cover_bet["comp_lia_cur_bank"] = parseFloat(( cover_bet["comp_liability"] + start_bankroll ).toFixed(2));
                                if ( cover_bet["comp_lia_cur_bank"] < max_comp_lia_cur_bank )
                                    cover_bet["comp_lia_draw_down"] = parseFloat(( cover_bet["comp_liability"] / max_comp_lia_cur_bank * 100 ).toFixed(2));
                                else
                                    cover_bet["comp_lia_draw_down"] = 0;

                            }
                            else {
                                cover_bet["comp_back_cur_bank"] = parseFloat(( cover_bet["comp_back"] + total_bets[tip_count-1]["comp_back_cur_bank"] ).toFixed(2));
                                max_comp_back_cur_bank = Math.max(max_comp_back_cur_bank, total_bets[tip_count-1]["comp_back_cur_bank"]);
                                if ( cover_bet["comp_back_cur_bank"] < max_comp_back_cur_bank )
                                    cover_bet["comp_back_draw_down"] = parseFloat(( cover_bet["comp_back"] / max_comp_back_cur_bank * 100 + total_bets[tip_count-1]["comp_back_draw_down"] ).toFixed(2));
                                else
                                    cover_bet["comp_back_draw_down"] = 0;

                                cover_bet["comp_pay_cur_bank"] = parseFloat(( cover_bet["comp_payout"] + total_bets[tip_count-1]["comp_pay_cur_bank"] ).toFixed(2));
                                max_comp_pay_cur_bank = Math.max(max_comp_pay_cur_bank, total_bets[tip_count-1]["comp_pay_cur_bank"]);
                                if ( cover_bet["comp_pay_cur_bank"] < max_comp_pay_cur_bank )
                                    cover_bet["comp_pay_draw_down"] = parseFloat(( cover_bet["comp_payout"] / max_comp_pay_cur_bank * 100 + total_bets[tip_count-1]["comp_pay_draw_down"] ).toFixed(2));
                                else
                                    cover_bet["comp_pay_draw_down"] = 0;

                                cover_bet["comp_lia_cur_bank"] = parseFloat(( cover_bet["comp_liability"] + total_bets[tip_count-1]["comp_lia_cur_bank"] ).toFixed(2));
                                max_comp_lia_cur_bank = Math.max(max_comp_lia_cur_bank, total_bets[tip_count-1]["comp_lia_cur_bank"]);
                                if ( cover_bet["comp_lia_cur_bank"] < max_comp_lia_cur_bank )
                                    cover_bet["comp_lia_draw_down"] = parseFloat(( cover_bet["comp_liability"] / max_comp_lia_cur_bank * 100 + total_bets[tip_count-1]["comp_lia_draw_down"] ).toFixed(2));
                                else
                                    cover_bet["comp_lia_draw_down"] = 0;
                            }

                            total_bets.push(cover_bet);

                            tip_count += 1;
                        }


                    }
                    this.total_bets = total_bets;
                    this.tot_bets_filtered = total_bets.length;

                    this.fromDateOptions = dateOptions;
                    this.toDateOptions = dateOptions;

                    this.fromDate = dateOptions.length > 0 ? dateOptions[0].value : "";
                    this.toDate = dateOptions.length > 0 ? dateOptions[dateOptions.length - 1].value : "";

                    this.sortJSON(countryLeague_dic, "country_league", "123");
                    this.leagueOptions[0].leagues = countryLeague_dic;
                    this.leagueList = countryLeague_dic;

 
                    
                }).finally(() => {
                    this.runTimer(false);
                    
                });
            },
            handleDetailClick() {
                const {id, userId} = this.$route.params; 
                let routeData = this.$router.resolve({
                    name: 'UserStrategyStat',
                    params: {
                        id: id,
                        userId: userId
                    }
                });
                window.open(routeData.href, '_blank');
            },
            handleFinancialClick() {
                const {id, userId} = this.$route.params; 
                let routeData = this.$router.resolve({
                    name: 'UserStrategyFinancial',
                    params: {
                        id: id,
                        userId: userId
                    }
                });
                window.open(routeData.href, '_blank');
            },
             handleStatsClick() {
                const {id, userId} = this.$route.params; 
                let routeData = this.$router.resolve({
                    name: 'UserStrategyStats',
                    params: {
                        id: id,
                        userId: userId
                    }
                });
                window.open(routeData.href, '_blank');
            },
            sortJSON(data, key){
                return data.sort(function(a, b) {
                    var x = a[key]; var y = b[key];
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                });
            },
            sortJSON1(data, key){
                return data.sort(function(a, b) {
                    var x = a[key]; var y = b[key];
                    return ((x > y) ? -1 : ((x < y) ? 1 : 0));
                });
            }
            
        },
        watch: {
            '$route.params': {
                deep: true,
                immediate: true,
                handler(val) {
                    if(!this.loading)
                        this.init();
                }
            }
        },
        mounted() {
            let user_id = localStorage.getItem('user_id');
            this.userId = parseInt(user_id);
           
        },
        created() {
        },
        beforeDestroy() {
            
        }
    }
</script>
<style>
    @media (max-width: 576px){
        .strategy_stats_button {
            font-size: 8px;
        }
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
   .user-stat-page-container {
       .stat {
           display: flex;
           justify-content: space-between;
           margin-bottom: 20px;
           div {
               text-align: center;
           }
           .username {
               div {
                   text-align: left;
               }
               .vue-avatar--wrapper {
                    display: inline-flex !important;
                    margin-right: 5px;
                }
           }
       }
       .username{
           ::v-deep .d-flex{
               .parent_avatar{
                   .vue-avatar--wrapper{
                       border: 5px solid white !important;
                   }
               }
           }
       }
       .header {
           .header-item {
                display: flex;
                justify-content: space-between;
                position: relative;
                div {
                    display: flex;
                }
                .settled-lost {
                    font-weight: 700;
                    color: #FF0000;
                }
                .settled-won {
                    font-weight: 700;
                    color: #00FF00;
                }
           }
       }
       .unread-mark {
           top: 0px;
           left: 0px;
       }
       .note-box {
           position: relative;
           margin-bottom: 20px;
           .note {
               padding: 5px;
               margin: 0 0 10px;
               min-height: 70px;
               background-color: #FEE;
               border-radius: 6px;
           }
           .action-box {
               display: flex;
               .action {
                   border-radius: 5px;
                   padding: 0 5px;
                   margin-right: 10px;
                   min-width: 70px;
                   text-align: center;
                   background-color: rgba(0,0,0,0.1);
                   &.selected {
                       background-color: #39F;
                       color: #FFF;
                   }
               }
           }
       }
       .comments {
           padding: 0 0 0 40px;
           .comment {
               position: relative;
               .comment-header {
                   display: flex;
                   align-items: center;
                   .vue-avatar--wrapper {
                       margin-right: 15px;
                   }
               }
                p {
                    padding-left: 45px;
                }
           }
       }
       .post-comment {
           text-align: right;
           margin-bottom: 10px;
           .btn {
           }
       }
    }   
    .c-callout {
        padding: 1rem;
        margin-top: 50px;
        background-color: #eee !important;
    }
    .strategy_name1{
        text-align: center;
        font-weight: 800;
        font-size: 18px;
        margin-bottom: 0;
    }
    .sub_strategy_name_bar{
        height: 50px;
        background-color: cadetblue;
        color: white;
        font-size: 22px;
        text-align: center;
        padding: 6px;
        font-weight: 700;
    }
    .stat{
        background-color: #5f9ea0;
        color: white;
        padding: 5px 100px 5px 140px;
        position: relative;
        margin-top: 40px;
    }
    .username{
        position: absolute;
        top: 32px;
        left: 60px;
        z-index: 1000;
    }
    .tip_body{
        background-color: whitesmoke;
    }

    .limegreen {
        color: limegreen
    }
    .red {
        color: red
    }

    .strategy-name {
        margin: auto;
        font-size: 22px;
        font-weight: bold;
    }
    .stat_button {
        min-width: 100px
    }
    .positive-mark {
        color: green
    }
    .negative-mark {
        color: red
    }
  
 
    @media (max-width: 576px){
       .stat{
           padding: 5px !important;
       }
       .username{
        left: 20px;
        top: 32px;

        }
        .stat{
            font-size: 10px !important;
            padding-left: 70px !important;
            padding-right: 10px !important;
        }
        .stat1{
            
            padding-left: 20px !important;
            padding-right: 20px !important;
        }
        .stat > button {
            font-size: 10px;
            padding: 5px !important;
        }
         .strategy-name {            
            font-size: 13px; 
        }
        .stat_button {
            min-width: 60px
        }
    } 

</style>